var messages = {
    "ACK": {
        "desc": "General Acknowledgment",
        "name": "ACK",
        "segments": {
            "desc": "General Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A01": {
        "desc": "Admit/Visit Notification",
        "name": "ADT_A01",
        "segments": {
            "desc": "Admit/Visit Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PDA",
                    "desc": "Patient Death and Autopsy",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A02": {
        "desc": "Transfer a Patient",
        "name": "ADT_A02",
        "segments": {
            "desc": "Transfer a Patient",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PDA",
                    "desc": "Patient Death and Autopsy",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A03": {
        "desc": "Discharge/End Visit",
        "name": "ADT_A03",
        "segments": {
            "desc": "Discharge/End Visit",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PDA",
                    "desc": "Patient Death and Autopsy",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A04": {
        "desc": "Register a Patient",
        "name": "ADT_A04",
        "segments": {
            "desc": "Register a Patient",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PDA",
                    "desc": "Patient Death and Autopsy",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A05": {
        "desc": "Pre-Admit a Patient",
        "name": "ADT_A05",
        "segments": {
            "desc": "Pre-Admit a Patient",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A06": {
        "desc": "Change an Outpatient to an Inpatient",
        "name": "ADT_A06",
        "segments": {
            "desc": "Change an Outpatient to an Inpatient",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MRG",
                    "desc": "Merge Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A07": {
        "desc": "Change an Inpatient to an Outpatient",
        "name": "ADT_A07",
        "segments": {
            "desc": "Change an Inpatient to an Outpatient",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MRG",
                    "desc": "Merge Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A08": {
        "desc": "Update Patient Information",
        "name": "ADT_A08",
        "segments": {
            "desc": "Update Patient Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PDA",
                    "desc": "Patient Death and Autopsy",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A09": {
        "desc": "Patient Departing - Tracking",
        "name": "ADT_A09",
        "segments": {
            "desc": "Patient Departing - Tracking",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A10": {
        "desc": "Patient Arriving - Tracking",
        "name": "ADT_A10",
        "segments": {
            "desc": "Patient Arriving - Tracking",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A11": {
        "desc": "Cancel Admit / Visit Notification",
        "name": "ADT_A11",
        "segments": {
            "desc": "Cancel Admit / Visit Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A12": {
        "desc": "Cancel Transfer",
        "name": "ADT_A12",
        "segments": {
            "desc": "Cancel Transfer",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A13": {
        "desc": "Cancel Discharge",
        "name": "ADT_A13",
        "segments": {
            "desc": "Cancel Discharge",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PDA",
                    "desc": "Patient Death and Autopsy",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A14": {
        "desc": "Pending Admit",
        "name": "ADT_A14",
        "segments": {
            "desc": "Pending Admit",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A15": {
        "desc": "Pending Transfer",
        "name": "ADT_A15",
        "segments": {
            "desc": "Pending Transfer",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A16": {
        "desc": "Pending Discharge",
        "name": "ADT_A16",
        "segments": {
            "desc": "Pending Discharge",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A17": {
        "desc": "Swap Patients",
        "name": "ADT_A17",
        "segments": {
            "desc": "Swap Patients",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient (1) Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient (1) Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient (1) Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result (1)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PID",
                    "desc": "Patient (2) Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient (2) Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient (2) Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result (2)",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A20": {
        "desc": "Bed Status Update",
        "name": "ADT_A20",
        "segments": {
            "desc": "Bed Status Update",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NPU",
                    "desc": "Non-Patient Update",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A21": {
        "desc": "Patient Goes on a Leave of Absence",
        "name": "ADT_A21",
        "segments": {
            "desc": "Patient Goes on a Leave of Absence",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A22": {
        "desc": "Patient Returns From a Leave of Absence",
        "name": "ADT_A22",
        "segments": {
            "desc": "Patient Returns From a Leave of Absence",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A23": {
        "desc": "Delete a Patient Record",
        "name": "ADT_A23",
        "segments": {
            "desc": "Delete a Patient Record",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A24": {
        "desc": "Link Patient Information",
        "name": "ADT_A24",
        "segments": {
            "desc": "Link Patient Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient (1) Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Patient (1) Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient (1) Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Patient (1) Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PID",
                    "desc": "Patient (2) Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Patient (2) Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient (2) Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Patient (2) Disability Information",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A25": {
        "desc": "Cancel Pending Discharge",
        "name": "ADT_A25",
        "segments": {
            "desc": "Cancel Pending Discharge",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A26": {
        "desc": "Cancel Pending Transfer",
        "name": "ADT_A26",
        "segments": {
            "desc": "Cancel Pending Transfer",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A27": {
        "desc": "Cancel Pending Admit",
        "name": "ADT_A27",
        "segments": {
            "desc": "Cancel Pending Admit",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A28": {
        "desc": "Add Person or Patient Information",
        "name": "ADT_A28",
        "segments": {
            "desc": "Add Person or Patient Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A29": {
        "desc": "Delete Person Information",
        "name": "ADT_A29",
        "segments": {
            "desc": "Delete Person Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A31": {
        "desc": "Update Person Information",
        "name": "ADT_A31",
        "segments": {
            "desc": "Update Person Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB1",
                    "desc": "Universal Bill Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UB2",
                    "desc": "Universal Bill 92 Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A32": {
        "desc": "Cancel Patient Arriving - Tracking",
        "name": "ADT_A32",
        "segments": {
            "desc": "Cancel Patient Arriving - Tracking",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A33": {
        "desc": "Cancel Patient Departing - Tracking",
        "name": "ADT_A33",
        "segments": {
            "desc": "Cancel Patient Departing - Tracking",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A37": {
        "desc": "Unlink Patient Information",
        "name": "ADT_A37",
        "segments": {
            "desc": "Unlink Patient Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient (1) Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient (1) Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PID",
                    "desc": "Patient (2) Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient (2) Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A38": {
        "desc": "Cancel Pre-Admit",
        "name": "ADT_A38",
        "segments": {
            "desc": "Cancel Pre-Admit",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A40": {
        "desc": "Merge Patient - Patient Identifier List",
        "name": "ADT_A40",
        "segments": {
            "desc": "Merge Patient - Patient Identifier List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A41": {
        "desc": "Merge Account - Patient Account Number",
        "name": "ADT_A41",
        "segments": {
            "desc": "Merge Account - Patient Account Number",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A42": {
        "desc": "Merge Visit - Visit Number",
        "name": "ADT_A42",
        "segments": {
            "desc": "Merge Visit - Visit Number",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A43": {
        "desc": "Move Patient Information - Patient Identifier List",
        "name": "ADT_A43",
        "segments": {
            "desc": "Move Patient Information - Patient Identifier List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A44": {
        "desc": "Move Account Information - Patient Account Number",
        "name": "ADT_A44",
        "segments": {
            "desc": "Move Account Information - Patient Account Number",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ARV",
                            "desc": "Access Restrictions",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A45": {
        "desc": "Move Visit Information - Visit Number",
        "name": "ADT_A45",
        "segments": {
            "desc": "Move Visit Information - Visit Number",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MERGE_INFO",
                    "desc": "Merge Info",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A47": {
        "desc": "Change Patient Identifier List",
        "name": "ADT_A47",
        "segments": {
            "desc": "Change Patient Identifier List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ARV",
                            "desc": "Access Restrictions",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A49": {
        "desc": "Change Patient Account Number",
        "name": "ADT_A49",
        "segments": {
            "desc": "Change Patient Account Number",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "MRG",
                            "desc": "Merge Information",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A50": {
        "desc": "Change Visit Number",
        "name": "ADT_A50",
        "segments": {
            "desc": "Change Visit Number",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MRG",
                    "desc": "Merge Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A51": {
        "desc": "Change Alternate Visit ID",
        "name": "ADT_A51",
        "segments": {
            "desc": "Change Alternate Visit ID",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MRG",
                    "desc": "Merge Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A52": {
        "desc": "Cancel Leave of Absence for a Patient",
        "name": "ADT_A52",
        "segments": {
            "desc": "Cancel Leave of Absence for a Patient",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A53": {
        "desc": "Cancel Patient Returns from a Leave of Absence",
        "name": "ADT_A53",
        "segments": {
            "desc": "Cancel Patient Returns from a Leave of Absence",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A54": {
        "desc": "Change Attending Doctor",
        "name": "ADT_A54",
        "segments": {
            "desc": "Change Attending Doctor",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A55": {
        "desc": "Cancel Change Attending Doctor",
        "name": "ADT_A55",
        "segments": {
            "desc": "Cancel Change Attending Doctor",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "ADT_A60": {
        "desc": "ADT Message",
        "name": "ADT_A60",
        "segments": {
            "desc": "ADT Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ARV",
                    "desc": "Access Restrictions",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ADVERSE_REACTION_GROUP",
                    "desc": "Adverse Reaction Group",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IAM",
                            "desc": "Patient adverse reaction information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "IAR",
                            "desc": "Allergy Reaction Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "ADT_A61": {
        "desc": "ADT Message",
        "name": "ADT_A61",
        "segments": {
            "desc": "ADT Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ADT_A62": {
        "desc": "ADT Message",
        "name": "ADT_A62",
        "segments": {
            "desc": "ADT Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info.",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "BAR_P01": {
        "desc": "Add Billing Account",
        "name": "BAR_P01",
        "segments": {
            "desc": "Add Billing Account",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DB1",
                            "desc": "Disability Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DRG",
                            "desc": "Diagnosis Related Group",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PROCEDURE",
                            "desc": "Procedure",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PR1",
                                    "desc": "Procedures",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance - Additional Info.",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance - Add'l Info. - Cert.",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ACC",
                            "desc": "Accident Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "UB1",
                            "desc": "Universal Bill Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "UB2",
                            "desc": "Universal Bill 92 Information",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "BAR_P02": {
        "desc": "Purge Billing Account",
        "name": "BAR_P02",
        "segments": {
            "desc": "Purge Billing Account",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "DB1",
                            "desc": "Disability Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "BAR_P05": {
        "desc": "Update Billing Account",
        "name": "BAR_P05",
        "segments": {
            "desc": "Update Billing Account",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DB1",
                            "desc": "Disability Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DRG",
                            "desc": "Diagnosis Related Group",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PROCEDURE",
                            "desc": "Procedure",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PR1",
                                    "desc": "Procedures",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance - Additional Info.",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance - Add'l Info. - Cert.",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ACC",
                            "desc": "Accident Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "UB1",
                            "desc": "Universal Bill Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "UB2",
                            "desc": "Universal Bill 92 Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ABS",
                            "desc": "Abstract",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "BLC",
                            "desc": "Blood Code",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RMI",
                            "desc": "Risk Management Incident",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "BAR_P06": {
        "desc": "End Billing Account",
        "name": "BAR_P06",
        "segments": {
            "desc": "End Billing Account",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "BAR_P10": {
        "desc": "Transmit Ambulatory Payment Classification (APC) groups",
        "name": "BAR_P10",
        "segments": {
            "desc": "Transmit Ambulatory Payment Classification (APC) groups",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GP1",
                    "desc": "Grouping/Reimbursement - Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "GP2",
                            "desc": "Grouping/reimbursement - Procedure",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "BAR_P12": {
        "desc": "Update Diagnosis/Procedures",
        "name": "BAR_P12",
        "segments": {
            "desc": "Update Diagnosis/Procedures",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedures",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "OBX",
                    "desc": "Observation/Result",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "BPS_O29": {
        "desc": "Blood Product dispense status Message",
        "name": "BPS_O29",
        "segments": {
            "desc": "Blood Product dispense status Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "BPO",
                            "desc": "Blood Product Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for BPO)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRODUCT",
                            "desc": "Product",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "BPX",
                                    "desc": "Blood Product Dispense Status",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for BPX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "BRP_O30": {
        "desc": "Description",
        "name": "BRP_O30",
        "segments": {
            "desc": "Description",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Response Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "BPO",
                                            "desc": "Blood Product Order",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "BPX",
                                            "desc": "Blood Product dispense status",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "BRT_O32": {
        "desc": "Description",
        "name": "BRT_O32",
        "segments": {
            "desc": "Description",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Response Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "BPO",
                                    "desc": "Blood Product Order",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "BTX",
                                    "desc": "Blood Product Transfusion/Disposition Status",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "BTS_O31": {
        "desc": "Blood Product Transfusion/Disposition Message",
        "name": "BTS_O31",
        "segments": {
            "desc": "Blood Product Transfusion/Disposition Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "BPO",
                            "desc": "Blood Product Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for BPO)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRODUCT_STATUS",
                            "desc": "Product Status",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "BTX",
                                    "desc": "Blood Product Transfusion/Disposition Status",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for BTX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "CCF_I22": {
        "desc": "Collaborative Care Fetch",
        "name": "CCF_I22",
        "segments": {
            "desc": "Collaborative Care Fetch",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "CCI_I22": {
        "desc": "Collaborative Care Information",
        "name": "CCI_I22",
        "segments": {
            "desc": "Collaborative Care Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "APPOINTMENT_HISTORY",
                    "desc": "Appointment History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RESOURCE_DETAIL",
                                    "desc": "Resource Detail",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS,AIG,AIL,AIP",
                                            "desc": "Resource Object",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "AIS",
                                                    "desc": "AIS Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIG",
                                                    "desc": "AIG Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIL",
                                                    "desc": "AIL Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIP",
                                                    "desc": "AIP Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "CLINICAL_HISTORY",
                    "desc": "Clinical History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_HISTORY_DETAIL",
                            "desc": "Clinical History Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,ODS,PR1,RF1,AL1,IAM,ACC,RMI,DB1,DG1,DRG,PDA",
                                    "desc": "Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RF1",
                                            "desc": "RF1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "AL1",
                                            "desc": "AL1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "IAM",
                                            "desc": "IAM Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ACC",
                                            "desc": "ACC Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RMI",
                                            "desc": "RMI Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DB1",
                                            "desc": "DB1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "DG1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DRG",
                                            "desc": "DRG Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PDA",
                                            "desc": "PDA Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ROLE_CLINICAL_HISTORY",
                            "desc": "Role Clinical History",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (CLINICAL_HISTORY)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISITS",
                    "desc": "Patient Visits",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "MEDICATION_HISTORY",
                    "desc": "Medication History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MEDICATION_ORDER_DETAIL",
                            "desc": "Medication Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ENCODING_DETAIL",
                            "desc": "Medication Encoding Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ADMINISTRATION_DETAIL",
                            "desc": "Medication Administration Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PROBLEM",
                            "desc": "Role Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Problem Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_GOAL",
                            "desc": "Role Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Goal Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PATHWAY",
                            "desc": "Role Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Pathway Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CCM_I21": {
        "desc": "Collaborative Care Message",
        "name": "CCM_I21",
        "segments": {
            "desc": "Collaborative Care Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "APPOINTMENT_HISTORY",
                    "desc": "Appointment History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RESOURCE_DETAIL",
                                    "desc": "Resource Detail",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": ",,,",
                                            "desc": "Resource Object",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": null,
                                                    "desc": "Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": null,
                                                    "desc": "Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": null,
                                                    "desc": "Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": null,
                                                    "desc": "Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "CLINICAL_HISTORY",
                    "desc": "Clinical History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_HISTORY_DETAIL",
                            "desc": "Clinical History Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": ",,,,,,,,,,,",
                                    "desc": "Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ROLE_CLINICAL_HISTORY",
                            "desc": "Role Clinical History",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": ",",
                                    "desc": "Role Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (CLINICAL_HISTORY)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISITS",
                    "desc": "Patient Visits",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "MEDICATION_HISTORY",
                    "desc": "Medication History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MEDICATION_ORDER_DETAIL",
                            "desc": "Medication Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ENCODING_DETAIL",
                            "desc": "Medication Encoding Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ADMINISTRATION_DETAIL",
                            "desc": "Medication Administration Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PROBLEM",
                            "desc": "Role Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": ",",
                                    "desc": "Role Problem Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_GOAL",
                            "desc": "Role Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": ",",
                                    "desc": "Role Goal Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PATHWAY",
                            "desc": "Role Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": ",",
                                    "desc": "Role Pathway Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": null,
                                            "desc": "Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CCQ_I19": {
        "desc": "Collaborative Care Referral",
        "name": "CCQ_I19",
        "segments": {
            "desc": "Collaborative Care Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CCR_I16": {
        "desc": "Collaborative Care Referral",
        "name": "CCR_I16",
        "segments": {
            "desc": "Collaborative Care Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "CLINICAL_ORDER",
                    "desc": "Clinical Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_ORDER_TIMING",
                            "desc": "Clinical Order Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CLINICAL_ORDER_DETAIL",
                            "desc": "Clinical Order Detail",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,RXO,ODS,PR1",
                                    "desc": "Clinical Order Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXO",
                                            "desc": "RXO Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "APPOINTMENT_HISTORY",
                    "desc": "Appointment History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RESOURCE_DETAIL",
                                    "desc": "Resource Detail",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS,AIG,AIL,AIP",
                                            "desc": "Resource Object",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "AIS",
                                                    "desc": "AIS Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIG",
                                                    "desc": "AIG Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIL",
                                                    "desc": "AIL Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIP",
                                                    "desc": "AIP Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "CLINICAL_HISTORY",
                    "desc": "Clinical History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_HISTORY_DETAIL",
                            "desc": "Clinical History Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,ODS,PR1,RF1,AL1,IAM,ACC,RMI,DB1,DG1,DRG",
                                    "desc": "Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RF1",
                                            "desc": "RF1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "AL1",
                                            "desc": "AL1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "IAM",
                                            "desc": "IAM Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ACC",
                                            "desc": "ACC Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RMI",
                                            "desc": "RMI Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DB1",
                                            "desc": "DB1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "DG1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DRG",
                                            "desc": "DRG Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ROLE_CLINICAL_HISTORY",
                            "desc": "Role Clinical History",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (CLINICAL_HISTORY)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISITS",
                    "desc": "Patient Visits",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "MEDICATION_HISTORY",
                    "desc": "Medication History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MEDICATION_ORDER_DETAIL",
                            "desc": "Medication Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ENCODING_DETAIL",
                            "desc": "Medication Encoding Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ADMINISTRATION_DETAIL",
                            "desc": "Medication Administration Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PROBLEM",
                            "desc": "Role Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Problem Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_GOAL",
                            "desc": "Role Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Goal Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PATHWAY",
                            "desc": "Role Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Pathway Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CCR_I17": {
        "desc": "Cancel Collaborative Care Referral",
        "name": "CCR_I17",
        "segments": {
            "desc": "Cancel Collaborative Care Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "CLINICAL_ORDER",
                    "desc": "Clinical Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_ORDER_TIMING",
                            "desc": "Clinical Order Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CLINICAL_ORDER_DETAIL",
                            "desc": "Clinical Order Detail",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,RXO,ODS,PR1",
                                    "desc": "Clinical Order Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXO",
                                            "desc": "RXO Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "APPOINTMENT_HISTORY",
                    "desc": "Appointment History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RESOURCE_DETAIL",
                                    "desc": "Resource Detail",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS,AIG,AIL,AIP",
                                            "desc": "Resource Object",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "AIS",
                                                    "desc": "AIS Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIG",
                                                    "desc": "AIG Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIL",
                                                    "desc": "AIL Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIP",
                                                    "desc": "AIP Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "CLINICAL_HISTORY",
                    "desc": "Clinical History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_HISTORY_DETAIL",
                            "desc": "Clinical History Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,ODS,PR1,RF1,AL1,IAM,ACC,RMI,DB1,DG1,DRG",
                                    "desc": "Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RF1",
                                            "desc": "RF1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "AL1",
                                            "desc": "AL1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "IAM",
                                            "desc": "IAM Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ACC",
                                            "desc": "ACC Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RMI",
                                            "desc": "RMI Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DB1",
                                            "desc": "DB1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "DG1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DRG",
                                            "desc": "DRG Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ROLE_CLINICAL_HISTORY",
                            "desc": "Role Clinical History",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (CLINICAL_HISTORY)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISITS",
                    "desc": "Patient Visits",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "MEDICATION_HISTORY",
                    "desc": "Medication History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MEDICATION_ORDER_DETAIL",
                            "desc": "Medication Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ENCODING_DETAIL",
                            "desc": "Medication Encoding Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ADMINISTRATION_DETAIL",
                            "desc": "Medication Administration Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PROBLEM",
                            "desc": "Role Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Problem Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_GOAL",
                            "desc": "Role Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Goal Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PATHWAY",
                            "desc": "Role Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Pathway Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CCU_I20": {
        "desc": "Collaborative Care Referral",
        "name": "CCU_I20",
        "segments": {
            "desc": "Collaborative Care Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "APPOINTMENT_HISTORY",
                    "desc": "Appointment History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RESOURCE_DETAIL",
                                    "desc": "Resource Detail",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS,AIG,AIL,AIP",
                                            "desc": "Resource Object",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "AIS",
                                                    "desc": "AIS Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIG",
                                                    "desc": "AIG Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIL",
                                                    "desc": "AIL Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIP",
                                                    "desc": "AIP Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "CLINICAL_HISTORY",
                    "desc": "Clinical History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_HISTORY_DETAIL",
                            "desc": "Clinical History Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,ODS,PR1,RF1,AL1,IAM,ACC,RMI,DB1,DG1,DRG,PDA",
                                    "desc": "Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RF1",
                                            "desc": "RF1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "AL1",
                                            "desc": "AL1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "IAM",
                                            "desc": "IAM Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ACC",
                                            "desc": "ACC Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RMI",
                                            "desc": "RMI Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DB1",
                                            "desc": "DB1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "DG1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DRG",
                                            "desc": "DRG Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PDA",
                                            "desc": "PDA Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ROLE_CLINICAL_HISTORY",
                            "desc": "Role Clinical History",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (CLINICAL_HISTORY)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISITS",
                    "desc": "Patient Visits",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "MEDICATION_HISTORY",
                    "desc": "Medication History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MEDICATION_ORDER_DETAIL",
                            "desc": "Medication Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ENCODING_DETAIL",
                            "desc": "Medication Encoding Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ADMINISTRATION_DETAIL",
                            "desc": "Medication Administration Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PROBLEM",
                            "desc": "Role Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Problem Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_GOAL",
                            "desc": "Role Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Goal Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PATHWAY",
                            "desc": "Role Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Pathway Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CQU_I19": {
        "desc": "Collaborative Care Referral",
        "name": "CQU_I19",
        "segments": {
            "desc": "Collaborative Care Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin / Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Info - Cert.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "APPOINTMENT_HISTORY",
                    "desc": "Appointment History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RESOURCE_DETAIL",
                                    "desc": "Resource Detail",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS,AIG,AIL,AIP",
                                            "desc": "Resource Object",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "AIS",
                                                    "desc": "AIS Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIG",
                                                    "desc": "AIG Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIL",
                                                    "desc": "AIL Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AIP",
                                                    "desc": "AIP Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "CLINICAL_HISTORY",
                    "desc": "Clinical History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CLINICAL_HISTORY_DETAIL",
                            "desc": "Clinical History Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR,ODS,PR1,RF1,AL1,IAM,ACC,RMI,DB1,DG1,DRG,PDA",
                                    "desc": "Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "OBR",
                                            "desc": "OBR Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ODS",
                                            "desc": "ODS Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PR1",
                                            "desc": "PR1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RF1",
                                            "desc": "RF1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "AL1",
                                            "desc": "AL1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "IAM",
                                            "desc": "IAM Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ACC",
                                            "desc": "ACC Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RMI",
                                            "desc": "RMI Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DB1",
                                            "desc": "DB1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "DG1 Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DRG",
                                            "desc": "DRG Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PDA",
                                            "desc": "PDA Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ROLE_CLINICAL_HISTORY",
                            "desc": "Role Clinical History",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Clinical History Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (CLINICAL_HISTORY)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISITS",
                    "desc": "Patient Visits",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "MEDICATION_HISTORY",
                    "desc": "Medication History",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MEDICATION_ORDER_DETAIL",
                            "desc": "Medication Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ENCODING_DETAIL",
                            "desc": "Medication Encoding Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "MEDICATION_ADMINISTRATION_DETAIL",
                            "desc": "Medication Administration Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PROBLEM",
                            "desc": "Role Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Problem Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_GOAL",
                            "desc": "Role Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Goal Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROLE_PATHWAY",
                            "desc": "Role Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL,PRD",
                                    "desc": "Role Pathway Object",
                                    "min": 0,
                                    "max": 0,
                                    "compounds": [
                                        {
                                            "name": "ROL",
                                            "desc": "ROL Segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRD",
                                            "desc": "PRD Segment",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "REL",
                    "desc": "Relationship",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "CRM_C01": {
        "desc": "Register a patient on a clinical trial",
        "name": "CRM_C01",
        "segments": {
            "desc": "Register a patient on a clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C02": {
        "desc": "Cancel a patient registration on clinical trial",
        "name": "CRM_C02",
        "segments": {
            "desc": "Cancel a patient registration on clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C03": {
        "desc": "Correct/update registration information",
        "name": "CRM_C03",
        "segments": {
            "desc": "Correct/update registration information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C04": {
        "desc": "Patient has gone off a clinical trial",
        "name": "CRM_C04",
        "segments": {
            "desc": "Patient has gone off a clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C05": {
        "desc": "Patient enters phase of clinical trial",
        "name": "CRM_C05",
        "segments": {
            "desc": "Patient enters phase of clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C06": {
        "desc": "Cancel patient entering a phase (clerical mistake)",
        "name": "CRM_C06",
        "segments": {
            "desc": "Cancel patient entering a phase (clerical mistake)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C07": {
        "desc": "Correct/update phase information",
        "name": "CRM_C07",
        "segments": {
            "desc": "Correct/update phase information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CRM_C08": {
        "desc": "Patient has gone off phase of clinical trial",
        "name": "CRM_C08",
        "segments": {
            "desc": "Patient has gone off phase of clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CSP",
                            "desc": "Clinical Study Phase",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "CSU_C09": {
        "desc": "Automated time intervals for reporting, like monthly",
        "name": "CSU_C09",
        "segments": {
            "desc": "Automated time intervals for reporting, like monthly",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "STUDY_PHASE",
                            "desc": "Study Phase",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "CSP",
                                    "desc": "Clinical Study Phase",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "STUDY_SCHEDULE",
                                    "desc": "Study Schedule",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "CSS",
                                            "desc": "Clinical Study Data Schedule",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "STUDY_OBSERVATION",
                                            "desc": "Study Observation",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "COMMON_ORDER",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Battery",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for observation)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_QTY",
                                                    "desc": "Timing Qty",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation Results",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participaton (for Observation Results)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "STUDY_PHARM",
                                            "desc": "Study Pharm",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "COMMON_ORDER",
                                                    "desc": "Common Order",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "ORC",
                                                            "desc": "COMMON_ORDER",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for COMMON_ORDER)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "RX_ADMIN",
                                                    "desc": "Rx Admin",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "RXA",
                                                            "desc": "Pharmacy Administration",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy Route",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy Administration)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "CSU_C10": {
        "desc": "Patient completes the clinical trial",
        "name": "CSU_C10",
        "segments": {
            "desc": "Patient completes the clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "STUDY_PHASE",
                            "desc": "Study Phase",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "CSP",
                                    "desc": "Clinical Study Phase",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "STUDY_SCHEDULE",
                                    "desc": "Study Schedule",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "CSS",
                                            "desc": "Clinical Study Data Schedule",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "STUDY_OBSERVATION",
                                            "desc": "Study Observation",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "COMMON_ORDER",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Battery",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for observation)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_QTY",
                                                    "desc": "Timing Qty",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation Results",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participaton (for Observation Results)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "STUDY_PHARM",
                                            "desc": "Study Pharm",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "COMMON_ORDER",
                                                    "desc": "Common Order",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "ORC",
                                                            "desc": "COMMON_ORDER",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for COMMON_ORDER)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "RX_ADMIN",
                                                    "desc": "Rx Admin",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "RXA",
                                                            "desc": "Pharmacy Administration",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy Route",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy Administration)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "CSU_C11": {
        "desc": "Patient completes a phase of the clinical trial",
        "name": "CSU_C11",
        "segments": {
            "desc": "Patient completes a phase of the clinical trial",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "STUDY_PHASE",
                            "desc": "Study Phase",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "CSP",
                                    "desc": "Clinical Study Phase",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "STUDY_SCHEDULE",
                                    "desc": "Study Schedule",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "CSS",
                                            "desc": "Clinical Study Data Schedule",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "STUDY_OBSERVATION",
                                            "desc": "Study Observation",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "COMMON_ORDER",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Battery",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for observation)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_QTY",
                                                    "desc": "Timing Qty",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation Results",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participaton (for Observation Results)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "STUDY_PHARM",
                                            "desc": "Study Pharm",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "COMMON_ORDER",
                                                    "desc": "Common Order",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "ORC",
                                                            "desc": "COMMON_ORDER",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for COMMON_ORDER)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "RX_ADMIN",
                                                    "desc": "Rx Admin",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "RXA",
                                                            "desc": "Pharmacy Administration",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy Route",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy Administration)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "CSU_C12": {
        "desc": "Update/correction of patient order/result information",
        "name": "CSU_C12",
        "segments": {
            "desc": "Update/correction of patient order/result information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CSR",
                            "desc": "Clinical Study Registration",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "STUDY_PHASE",
                            "desc": "Study Phase",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "CSP",
                                    "desc": "Clinical Study Phase",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "STUDY_SCHEDULE",
                                    "desc": "Study Schedule",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "CSS",
                                            "desc": "Clinical Study Data Schedule",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "STUDY_OBSERVATION",
                                            "desc": "Study Observation",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "COMMON_ORDER",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Battery",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for observation)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_QTY",
                                                    "desc": "Timing Qty",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation Results",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participaton (for Observation Results)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "STUDY_PHARM",
                                            "desc": "Study Pharm",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "COMMON_ORDER",
                                                    "desc": "Common Order",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "ORC",
                                                            "desc": "COMMON_ORDER",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for COMMON_ORDER)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "RX_ADMIN",
                                                    "desc": "Rx Admin",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "RXA",
                                                            "desc": "Pharmacy Administration",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy Route",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy Administration)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "DFT_P03": {
        "desc": "Detail Financial Transaction",
        "name": "DFT_P03",
        "segments": {
            "desc": "Detail Financial Transaction",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER (across all FT1s)",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "TIMING_QUANTITY",
                            "desc": "Timing Quantity",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OBR",
                                    "desc": "Order Detail Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (on Order Detail)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observations / Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (on Result)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "FINANCIAL",
                    "desc": "Financial",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (on line item - FT1 - above)",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "FINANCIAL_PROCEDURE",
                            "desc": "Financial Procedure",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PR1",
                                    "desc": "Procedure",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FINANCIAL_COMMON_ORDER",
                            "desc": "Financial Common Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "COMMON_ORDER (specific to above FT1)",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "FINANCIAL_TIMING_QUANTITY",
                                    "desc": "Financial Timing Quantity",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "FINANCIAL_ORDER",
                                    "desc": "Financial Order",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Order Detail Segment",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (on Order Detail)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "FINANCIAL_OBSERVATION",
                                    "desc": "Financial Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observations / Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (on Result)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis (global across all FT1s)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor (global across all FT1s)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance (global across all FT1s)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance - Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance - AddвЂ™l Info. - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "DFT_P11": {
        "desc": "Detail Financial Transaction - Expanded",
        "name": "DFT_P11",
        "segments": {
            "desc": "Detail Financial Transaction - Expanded",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Info",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DB1",
                    "desc": "Disability Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER (global across all FT1s)",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "TIMING_QUANTITY",
                            "desc": "Timing Quantity",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OBR",
                                    "desc": "Order Detail Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (on Order Detail)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observations / Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (on Result)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis (global across all FT1s)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group (global across all FT1s)",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor (global across all FT1s)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance (global across all FT1s)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance - Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance - AddвЂ™l Info. - Cert.",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "FINANCIAL",
                    "desc": "Financial",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "FINANCIAL_PROCEDURE",
                            "desc": "Financial Procedure",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PR1",
                                    "desc": "Procedure",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FINANCIAL_COMMON_ORDER",
                            "desc": "Financial Common Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "COMMON_ORDER (specific to above FT1)",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "FINANCIAL_TIMING_QUANTITY",
                                    "desc": "Financial Timing Quantity",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "FINANCIAL_ORDER",
                                    "desc": "Financial Order",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Order Detail Segment",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (on Order Detail)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "FINANCIAL_OBSERVATION",
                                    "desc": "Financial Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observations / Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (on Result)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis (specific to above FT1)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DRG",
                            "desc": "Diagnosis Related Group (specific to above FT1)",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor (specific to above FT1)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "FINANCIAL_INSURANCE",
                            "desc": "Financial Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance (specific to above FT1)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance - Additional Info.",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance - AddвЂ™l Info. - Cert.",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EAC_U07": {
        "desc": "Equipment Command Message",
        "name": "EAC_U07",
        "segments": {
            "desc": "Equipment Command Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMAND",
                    "desc": "Command",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ECD",
                            "desc": "Equipment Command Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/quantity",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "SPECIMEN_CONTAINER",
                            "desc": "Specimen Container",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "SAC",
                                    "desc": "Specimen Container Detail",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CNS",
                            "desc": "Clear Notification",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "EAN_U09": {
        "desc": "Equipment Status Message",
        "name": "EAN_U09",
        "segments": {
            "desc": "Equipment Status Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NOTIFICATION",
                    "desc": "Notification",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "NDS",
                            "desc": "Notification Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notification Note",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "EAR_U08": {
        "desc": "Equipment Command Message",
        "name": "EAR_U08",
        "segments": {
            "desc": "Equipment Command Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMAND_RESPONSE",
                    "desc": "Command Response",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ECD",
                            "desc": "Equipment Command Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPECIMEN_CONTAINER",
                            "desc": "Specimen Container",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "SAC",
                                    "desc": "Specimen Container Detail",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ECR",
                            "desc": "Equipment Command Response",
                            "min": 1,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "EHC_E01": {
        "desc": "Submit HealthCare Services Invoice",
        "name": "EHC_E01",
        "segments": {
            "desc": "Submit HealthCare Services Invoice",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INVOICE_INFORMATION",
                    "desc": "Invoice Information",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "IVC",
                            "desc": "Invoice",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PYE",
                            "desc": "Payee Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "LOC",
                            "desc": "Location Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRODUCT_SERVICE_SECTION",
                            "desc": "Product Service Section",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSS",
                                    "desc": "Product/Service Section",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRODUCT_SERVICE_GROUP",
                                    "desc": "Product Service Group",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PSG",
                                            "desc": "Product/Service Group",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "LOC",
                                            "desc": "Location Identification",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ROL",
                                            "desc": "Role",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PATIENT_INFO",
                                            "desc": "Patient Info",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PID",
                                                    "desc": "Person Identification",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PV1",
                                                    "desc": "Patient Visit",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PV2",
                                                    "desc": "Patient Visit - Additional Info",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ACC",
                                                    "desc": "Accident",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "INSURANCE",
                                                    "desc": "Insurance",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "IN1",
                                                            "desc": "Insurance",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "IN2",
                                                            "desc": "Insurance Additional Info",
                                                            "min": 0,
                                                            "max": 1
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "DIAGNOSIS",
                                                    "desc": "Diagnosis",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "DG1",
                                                            "desc": "Diagnosis",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes and Comments",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PRODUCT_SERVICE_LINE_ITEM",
                                            "desc": "Product Service Line Item",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PSL",
                                                    "desc": "Product/Service Line Item",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ADJ",
                                                    "desc": "Adjustment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "AUT",
                                                    "desc": "Authorization Information",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "LOC",
                                                    "desc": "Location Identification",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROCEDURE",
                                            "desc": "Procedure",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PR1",
                                                    "desc": "Procedures",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "INVOICE_PROCESSING",
                                            "desc": "Invoice Processing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "IPR",
                                                    "desc": "Invoice Processing Results",
                                                    "min": 1,
                                                    "max": 1
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E02": {
        "desc": "Cancel HealthCare Services Invoice",
        "name": "EHC_E02",
        "segments": {
            "desc": "Cancel HealthCare Services Invoice",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Secondary Header",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INVOICE_INFORMATION",
                    "desc": "Invoice Information",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "IVC",
                            "desc": "Invoice",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PYE",
                            "desc": "Payee Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRODUCT_SERVICE_SECTION",
                            "desc": "Product Service Section",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSS",
                                    "desc": "",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PSG",
                                    "desc": "Psg",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PSG",
                                            "desc": "Product/Service Group",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PSL",
                                            "desc": "Product/Service Line Item",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E04": {
        "desc": "Re-Assess HealthCare Services Invoice Request",
        "name": "EHC_E04",
        "segments": {
            "desc": "Re-Assess HealthCare Services Invoice Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "REASSESSMENT_REQUEST_INFO",
                    "desc": "Reassessment Request Info",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "IVC",
                            "desc": "Invoice",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRODUCT_SERVICE_SECTION",
                            "desc": "Product Service Section",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSS",
                                    "desc": "Product/Service Section",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRODUCT_SERVICE_GROUP",
                                    "desc": "Product Service Group",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PSG",
                                            "desc": "Product/Service Group",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PSL",
                                            "desc": "Product/Service Line Item",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E10": {
        "desc": "Edit/Adjudication Results",
        "name": "EHC_E10",
        "segments": {
            "desc": "Edit/Adjudication Results",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INVOICE_PROCESSING_RESULTS_INFO",
                    "desc": "Invoice Processing Results Info",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "IPR",
                            "desc": "Invoice Processing Results",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PYE",
                            "desc": "Payee",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IVC",
                            "desc": "Invoice",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRODUCT_SERVICE_SECTION",
                            "desc": "Product Service Section",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSS",
                                    "desc": "Product/Service Section",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRODUCT_SERVICE_GROUP",
                                    "desc": "Product Service Group",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PSG",
                                            "desc": "Product/Service Group",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRODUCT_SERVICE_LINE_INFO",
                                            "desc": "Product Service Line Info",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PSL",
                                                    "desc": "Product/Service Line Item",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ADJ",
                                                    "desc": "Adjustment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E12": {
        "desc": "Request Additional Information",
        "name": "EHC_E12",
        "segments": {
            "desc": "Request Additional Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RFI",
                    "desc": "Request for Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CTD",
                    "desc": "Contact Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "IVC",
                    "desc": "Invoice",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PSS",
                    "desc": "Product/Service Section",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PSG",
                    "desc": "Product/Service Group",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Person Identification",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PSL",
                    "desc": "Product/Service Line Item",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "REQUEST",
                    "desc": "Request",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation Results",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E13": {
        "desc": "Additional Information Response",
        "name": "EHC_E13",
        "segments": {
            "desc": "Additional Information Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RFI",
                    "desc": "Request for Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CTD",
                    "desc": "Contact Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "IVC",
                    "desc": "Invoice",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PSS",
                    "desc": "Product/Service Section",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PSG",
                    "desc": "Product/Service Group",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Person Identification",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PSL",
                    "desc": "Product/Service Line Item",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "REQUEST",
                    "desc": "Request",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "RESPONSE",
                            "desc": "Response",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "TXA",
                                    "desc": "Transcription Document Header",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E15": {
        "desc": "Payment/Remittance Advice",
        "name": "EHC_E15",
        "segments": {
            "desc": "Payment/Remittance Advice",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PAYMENT_REMITTANCE_HEADER_INFO",
                    "desc": "Payment Remittance Header Info",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "PMT",
                            "desc": "Payment Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PYE",
                            "desc": "Payee Information",
                            "min": 1,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PAYMENT_REMITTANCE_DETAIL_INFO",
                    "desc": "Payment Remittance Detail Info",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IPR",
                            "desc": "Invoice Processing Results",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IVC",
                            "desc": "Invoice",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRODUCT_SERVICE_SECTION",
                            "desc": "Product Service Section",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSS",
                                    "desc": "Product/Service Section",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRODUCT_SERVICE_GROUP",
                                    "desc": "Product Service Group",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PSG",
                                            "desc": "Product/Service Group",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PSL_ITEM_INFO",
                                            "desc": "Psl Item Info",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PSL",
                                                    "desc": "Product/Service Line Item",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ADJ",
                                                    "desc": "Adjustment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ADJUSTMENT_PAYEE",
                    "desc": "Adjustment Payee",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ADJ",
                            "desc": "Adjustment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E20": {
        "desc": "Submit Authorization Request",
        "name": "EHC_E20",
        "segments": {
            "desc": "Submit Authorization Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AUTHORIZATION_REQUEST",
                    "desc": "Authorization Request",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "IVC",
                            "desc": "Invoice Header",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "LOC",
                            "desc": "Location Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Provider Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PAT_INFO",
                            "desc": "Pat Info",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Person Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ACC",
                                    "desc": "Accident",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "INSURANCE",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "IN1",
                                            "desc": "Insurance",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "IN2",
                                            "desc": "Insurance Additional Info",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                },
                                {
                                    "name": "DIAGNOSIS",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "GROUP",
                                            "desc": "Group",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "DG1",
                                                    "desc": "Diagnosis",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PSL_ITEM_INFO",
                            "desc": "Psl Item Info",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSL",
                                    "desc": "Product/Service Line Item",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ADJ",
                                    "desc": "Adjustment",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "LOC",
                                    "desc": "Location Identification",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ROL",
                                    "desc": "Role",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E21": {
        "desc": "Cancel Authorization Request",
        "name": "EHC_E21",
        "segments": {
            "desc": "Cancel Authorization Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AUTHORIZATION_REQUEST",
                    "desc": "Authorization Request",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "IVC",
                            "desc": "Invoice Header",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PSL_ITEM_INFO",
                            "desc": "Psl Item Info",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PSL",
                                    "desc": "Product/Service Line Item",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "AUT",
                                    "desc": "Authorization",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "EHC_E24": {
        "desc": "Authorization Response",
        "name": "EHC_E24",
        "segments": {
            "desc": "Authorization Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "IVC",
                    "desc": "Authorization Response Info",
                    "min": 0,
                    "max": 0,
                    "compounds": [
                        {
                            "name": "IVC",
                            "desc": "IVC Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "ESR_U02": {
        "desc": "Equipment Status Message",
        "name": "ESR_U02",
        "segments": {
            "desc": "Equipment Status Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ESU_U01": {
        "desc": "Equipment Status Message",
        "name": "ESU_U01",
        "segments": {
            "desc": "Equipment Status Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ISD",
                    "desc": "Interaction Status Detail",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "INR_U06": {
        "desc": "Inventory Request Message",
        "name": "INR_U06",
        "segments": {
            "desc": "Inventory Request Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "INV",
                    "desc": "Inventory Detail",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "INU_U05": {
        "desc": "Inventory Update Message",
        "name": "INU_U05",
        "segments": {
            "desc": "Inventory Update Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "INV",
                    "desc": "Inventory Detail",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "LSR_U13": {
        "desc": "Equipment Log/Service Message",
        "name": "LSR_U13",
        "segments": {
            "desc": "Equipment Log/Service Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "EQP",
                    "desc": "Equipment Log/Service",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "LSU_U12": {
        "desc": "Equipment Log/Service Message",
        "name": "LSU_U12",
        "segments": {
            "desc": "Equipment Log/Service Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "EQP",
                    "desc": "Equipment Log/Service",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "MDM_T01": {
        "desc": "Original Document Notification",
        "name": "MDM_T01",
        "segments": {
            "desc": "Original Document Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the observation request (OBR)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MDM_T02": {
        "desc": "Original Document Notification & Content",
        "name": "MDM_T02",
        "segments": {
            "desc": "Original Document Notification & Content",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the observation (OBR)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GROUP",
                    "desc": "Group",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation/Result (one or more required)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the observation (OBX)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MDM_T03": {
        "desc": "Document Status Change Notification",
        "name": "MDM_T03",
        "segments": {
            "desc": "Document Status Change Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type (",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MDM_T04": {
        "desc": "Document Status Change Notification & Content",
        "name": "MDM_T04",
        "segments": {
            "desc": "Document Status Change Notification & Content",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GROUP",
                    "desc": "Group",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation/Result (one or more required)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments segment for OBX",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MDM_T05": {
        "desc": "Document Addendum Notification",
        "name": "MDM_T05",
        "segments": {
            "desc": "Document Addendum Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MDM_T06": {
        "desc": "Document Addendum Notification & Content",
        "name": "MDM_T06",
        "segments": {
            "desc": "Document Addendum Notification & Content",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GROUP",
                    "desc": "Group",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation/Result (one or more required)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBX",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MDM_T07": {
        "desc": "Document Edit Notification",
        "name": "MDM_T07",
        "segments": {
            "desc": "Document Edit Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MDM_T08": {
        "desc": "Document Edit Notification & Content",
        "name": "MDM_T08",
        "segments": {
            "desc": "Document Edit Notification & Content",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GROUP",
                    "desc": "Group",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation/Result (one or more required)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBX",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MDM_T09": {
        "desc": "Document Replacement Notification",
        "name": "MDM_T09",
        "segments": {
            "desc": "Document Replacement Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MDM_T10": {
        "desc": "Document Replacement Notification & Content",
        "name": "MDM_T10",
        "segments": {
            "desc": "Document Replacement Notification & Content",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GROUP",
                    "desc": "Group",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation/Result (one or more required)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBX",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MDM_T11": {
        "desc": "Document Cancel Notification",
        "name": "MDM_T11",
        "segments": {
            "desc": "Document Cancel Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "COMMON_ORDER",
                    "desc": "Common Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation request segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and comments about the OBR",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "TXA",
                    "desc": "Document Notification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "CON",
                    "desc": "Consent Segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M02": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M02",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M04": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M04",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M05": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M05",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M06": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M06",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M07": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M07",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M08": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M08",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M09": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M09",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M10": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M10",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M11": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M11",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M12": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M12",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M13": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M13",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M14": {
        "desc": "Master File Application Acknowledgment",
        "name": "MFK_M14",
        "segments": {
            "desc": "Master File Application Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M15": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M15",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M16": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M16",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK segment",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFK_M17": {
        "desc": "Master File Acknowledgment",
        "name": "MFK_M17",
        "segments": {
            "desc": "Master File Acknowledgment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFA",
                    "desc": "Master File ACK",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "MFN_M02": {
        "desc": "Master File Notification for Staff/Practitioner",
        "name": "MFN_M02",
        "segments": {
            "desc": "Master File Notification for Staff/Practitioner",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_STAFF",
                    "desc": "Mf Staff",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "STF",
                            "desc": "Staff Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRA",
                            "desc": "Practitioner Detail",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ORG",
                            "desc": "Practitioner Organization Unit Segment",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AFF",
                            "desc": "Professional Affiliation",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "LAN",
                            "desc": "Language Detail",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "EDU",
                            "desc": "Educational Detail",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CER",
                            "desc": "Certificate Detail",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the STF",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M04": {
        "desc": "Master File Notification - Charge Description",
        "name": "MFN_M04",
        "segments": {
            "desc": "Master File Notification - Charge Description",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_CDM",
                    "desc": "Mf Cdm",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CDM",
                            "desc": "Charge Description Master",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRC",
                            "desc": "Price Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M05": {
        "desc": "Master File Notification - Patient Location",
        "name": "MFN_M05",
        "segments": {
            "desc": "Master File Notification - Patient Location",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_LOCATION",
                    "desc": "Mf Location",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "LOC",
                            "desc": "Patient Location Master",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "LCH",
                            "desc": "Location Characteristic",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "LRL",
                            "desc": "Location Relationship",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "MF_LOC_DEPT",
                            "desc": "Mf Loc Dept",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "LDP",
                                    "desc": "Location Department",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "LCH",
                                    "desc": "Location Characteristic",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "LCC",
                                    "desc": "Location Charge Code",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M06": {
        "desc": "Master File Notification - Clinical Study with Phases and Schedules",
        "name": "MFN_M06",
        "segments": {
            "desc": "Master File Notification - Clinical Study with Phases and Schedules",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_CLIN_STUDY",
                    "desc": "Mf Clin Study",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CM0",
                            "desc": "Clinical Study Master",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MF_PHASE_SCHED_DETAIL",
                            "desc": "Mf Phase Sched Detail",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "CM1",
                                    "desc": "Clinical Study Phase",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CM2",
                                    "desc": "Clinical Study Schedule",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M07": {
        "desc": "Master File Notification - Clinical Study without Phases but with Schedules",
        "name": "MFN_M07",
        "segments": {
            "desc": "Master File Notification - Clinical Study without Phases but with Schedules",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_CLIN_STUDY_SCHED",
                    "desc": "Mf Clin Study Sched",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CM0",
                            "desc": "Clinical Study Master",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CM2",
                            "desc": "Clinical Study Schedule",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M08": {
        "desc": "Master File Notification - Test/Observation (Numeric)",
        "name": "MFN_M08",
        "segments": {
            "desc": "Master File Notification - Test/Observation (Numeric)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_TEST_NUMERIC",
                    "desc": "Mf Test Numeric",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM1",
                            "desc": "General Segment (Fields That Apply to Most Observations)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM2",
                            "desc": "Numeric Observation Segment",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OM3",
                            "desc": "Categorical Service/Test/Observation Segment",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OM4",
                            "desc": "Observations that Require Specimens",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M09": {
        "desc": "Master File Notification - Test/Observation (Categorical)",
        "name": "MFN_M09",
        "segments": {
            "desc": "Master File Notification - Test/Observation (Categorical)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_TEST_CATEGORICAL",
                    "desc": "Mf Test Categorical",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM1",
                            "desc": "General Segment (Fields That Apply to Most Observations)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MF_TEST_CAT_DETAIL",
                            "desc": "Mf Test Cat Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OM3",
                                    "desc": "Categorical Service/Test/Observation Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OM4",
                                    "desc": "Observations that Require Specimens",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M10": {
        "desc": "Master File Notification - Test/Observation Batteries",
        "name": "MFN_M10",
        "segments": {
            "desc": "Master File Notification - Test/Observation Batteries",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_TEST_BATTERIES",
                    "desc": "Mf Test Batteries",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM1",
                            "desc": "General Segment (Fields That Apply to Most Observations)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MF_TEST_BATT_DETAIL",
                            "desc": "Mf Test Batt Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OM5",
                                    "desc": "Observation Batteries",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OM4",
                                    "desc": "Observations that Require Specimens",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M11": {
        "desc": "Master File Notification - Test/Calculated Observations",
        "name": "MFN_M11",
        "segments": {
            "desc": "Master File Notification - Test/Calculated Observations",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_TEST_CALCULATED",
                    "desc": "Mf Test Calculated",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM1",
                            "desc": "General Segment (Fields That Apply to Most Observations)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "MF_TEST_CALC_DETAIL",
                            "desc": "Mf Test Calc Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OM6",
                                    "desc": "Observations Calculated from Other Observations",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OM2",
                                    "desc": "Numeric Observation Segment",
                                    "min": 1,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M12": {
        "desc": "Master File Notification - Additional Basic Observation/Service Attributes",
        "name": "MFN_M12",
        "segments": {
            "desc": "Master File Notification - Additional Basic Observation/Service Attributes",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_OBS_ATTRIBUTES",
                    "desc": "Mf Obs Attributes",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM1",
                            "desc": "General Segment (Fields That Apply to Most Observations)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OM7",
                            "desc": "Other Basic Observation/Service Attributes",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M13": {
        "desc": "Master File Notification - General",
        "name": "MFN_M13",
        "segments": {
            "desc": "Master File Notification - General",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MFE",
                    "desc": "Master File Entry",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "MFN_M14": {
        "desc": "Master File Notification - Site Defined",
        "name": "MFN_M14",
        "segments": {
            "desc": "Master File Notification - Site Defined",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_SITE_DEFINED",
                    "desc": "Mf Site Defined",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M15": {
        "desc": "Master File Notification - Inventory Item",
        "name": "MFN_M15",
        "segments": {
            "desc": "Master File Notification - Inventory Item",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_INV_ITEM",
                    "desc": "Mf Inv Item",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IIM",
                            "desc": "Inventory Item Master",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M16": {
        "desc": "Master File Notification - Inventory Item Enhanced",
        "name": "MFN_M16",
        "segments": {
            "desc": "Master File Notification - Inventory Item Enhanced",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MATERIAL_ITEM_RECORD",
                    "desc": "Material Item Record",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ITM",
                            "desc": "Material Item",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes for ITM",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "STERILIZATION",
                            "desc": "Sterilization",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "STZ",
                                    "desc": "Sterilization Parameters",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes for STZ",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PURCHASING_VENDOR",
                            "desc": "Purchasing Vendor",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "VND",
                                    "desc": "Purchasing Vendor",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PACKAGING",
                                    "desc": "Packaging",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PKG",
                                            "desc": "Packaging",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PCE",
                                            "desc": "Patient Charge Cost Center Exception",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "MATERIAL_LOCATION",
                            "desc": "Material Location",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IVT",
                                    "desc": "Material Location",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ILT",
                                    "desc": "Material Lot/Quantity",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes for IVT",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "MFN_M17": {
        "desc": "Master File Notification - DRG",
        "name": "MFN_M17",
        "segments": {
            "desc": "Master File Notification - DRG",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MFI",
                    "desc": "Master File Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MF_DRG",
                    "desc": "Mf Drg",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "MFE",
                            "desc": "Master File Entry",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "DMI",
                            "desc": "DRG Master",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "NMD_N02": {
        "desc": "Application Management Data",
        "name": "NMD_N02",
        "segments": {
            "desc": "Application Management Data",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "CLOCK_AND_STATS_WITH_NOTES",
                    "desc": "Clock And Stats With Notes",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "CLOCK",
                            "desc": "Clock",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "NCK",
                                    "desc": "System Clock",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for NCK",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "APP_STATS",
                            "desc": "App Stats",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "NST",
                                    "desc": "Application control-level Statistics",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for NST",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "APP_STATUS",
                            "desc": "App Status",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "NSC",
                                    "desc": "Application Status Change",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for NSC",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "OMB_O27": {
        "desc": "Blood Product Order Message",
        "name": "OMB_O27",
        "segments": {
            "desc": "Blood Product Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "BPO",
                            "desc": "Blood Product Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPM",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Results)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OMD_O03": {
        "desc": "Dietary Order",
        "name": "OMD_O03",
        "segments": {
            "desc": "Dietary Order",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER_DIET",
                    "desc": "Order Diet",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING_DIET",
                            "desc": "Timing Diet",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "DIET",
                            "desc": "Diet",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "ODS",
                                    "desc": "Dietary Orders, Suppl., Prefer.",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for ODS)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Results",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ORDER_TRAY",
                    "desc": "Order Tray",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING_TRAY",
                            "desc": "Timing Tray",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ODT",
                            "desc": "Diet Tray Instructions",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for ODT)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "OMG_O19": {
        "desc": "General Clinical Order Message",
        "name": "OMG_O19",
        "segments": {
            "desc": "General Clinical Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit- Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for COMMON_ORDER)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Detail)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Results)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPECIMEN_OBSERVATION",
                                    "desc": "Specimen Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Specimen Observation)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "CONTAINER",
                                    "desc": "Container",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SAC",
                                            "desc": "Specimen Container",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "CONTAINER_OBSERVATION",
                                            "desc": "Container Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Container Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRIOR_RESULT",
                            "desc": "Prior Result",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PATIENT_PRIOR",
                                    "desc": "Patient Prior",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PID",
                                            "desc": "Patient Identification  - previous result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PD1",
                                            "desc": "Additional Demographics - previous result",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Patient Prior)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PATIENT_VISIT_PRIOR",
                                    "desc": "Patient Visit Prior",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PV1",
                                            "desc": "Patient Visit           - previous result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PV2",
                                            "desc": "Patient Visit Add. Info - previous result",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Patient Visit Prior)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "AL1",
                                    "desc": "Allergy Information     - previous result",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ORDER_PRIOR",
                                    "desc": "Order Prior",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order            - previous result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "OBR",
                                            "desc": "Order Detail            - previous result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING_PRIOR",
                                            "desc": "Timing Prior",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments      - previous result",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Order Prior)  - previous result",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "CTD",
                                            "desc": "Contact Data            - previous result",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "OBSERVATION_PRIOR",
                                            "desc": "Observation Prior",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result      - previous result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Oservation Prior)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments      - previous result",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OMI_O23": {
        "desc": "Imaging Order Message",
        "name": "OMI_O23",
        "segments": {
            "desc": "Imaging Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit- Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBR",
                            "desc": "Observation",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Detail)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Results)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "IPC",
                            "desc": "Imaging Procedure Control",
                            "min": 1,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "OML_O21": {
        "desc": "Laboratory Order Message",
        "name": "OML_O21",
        "segments": {
            "desc": "Laboratory Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit- Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for COMMON_ORDER)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION_REQUEST",
                            "desc": "Observation Request",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OBR",
                                    "desc": "Observation Request",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TCD",
                                    "desc": "Test Code Details",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Detail)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation Request)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TCD",
                                            "desc": "Test Code Detail",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for Results)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "SPECIMEN",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SPM",
                                            "desc": "Specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "SPECIMEN_OBSERVATION",
                                            "desc": "Specimen Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result related to specimen",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Specimen Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "CONTAINER",
                                            "desc": "Container",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "SAC",
                                                    "desc": "Specimen Container",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "CONTAINER_OBSERVATION",
                                                    "desc": "Container Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result related to container",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Container Observation)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "PRIOR_RESULT",
                                    "desc": "Prior Result",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PATIENT_PRIOR",
                                            "desc": "Patient Prior",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "PID",
                                                    "desc": "Patient Identification  - previous result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PD1",
                                                    "desc": "Additional Demographics - previous result",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Patient Prior)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PATIENT_VISIT_PRIOR",
                                            "desc": "Patient Visit Prior",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "PV1",
                                                    "desc": "Patient Visit           - previous result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PV2",
                                                    "desc": "Patient Visit Add. Info - previous result",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Patient Visit Prior)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "AL1",
                                            "desc": "Allergy Information     - previous result",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_PRIOR",
                                            "desc": "Order Prior",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "Common Order            - previous result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "OBR",
                                                    "desc": "Order Detail            - previous result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments      - previous result",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Order Prior)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_PRIOR",
                                                    "desc": "Timing Prior",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBSERVATION_PRIOR",
                                                    "desc": "Observation Prior",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result      - previous result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation Prior)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes and Comments      - previous result",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OML_O33": {
        "desc": "Laboratory Order - Multiple Order Per Specimen Message",
        "name": "OML_O33",
        "segments": {
            "desc": "Laboratory Order - Multiple Order Per Specimen Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit- Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "SPECIMEN",
                    "desc": "Specimen",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SPM",
                            "desc": "Specimen",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPECIMEN_OBSERVATION",
                            "desc": "Specimen Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observations related to specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Specimen Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "SAC",
                            "desc": "Specimen Container",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for COMMON_ORDER)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBSERVATION_REQUEST",
                                    "desc": "Observation Request",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Observation Request",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TCD",
                                            "desc": "Test Code Details",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for Detail)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation Request)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "Diagnosis",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "OBSERVATION",
                                            "desc": "Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TCD",
                                                    "desc": "Test Code Detail",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for Results)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PRIOR_RESULT",
                                            "desc": "Prior Result",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PATIENT_PRIOR",
                                                    "desc": "Patient Prior",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "PID",
                                                            "desc": "Patient Identification  - previous result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PD1",
                                                            "desc": "Additional Demographics - previous result",
                                                            "min": 0,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Patient Prior)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "PATIENT_VISIT_PRIOR",
                                                    "desc": "Patient Visit Prior",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "PV1",
                                                            "desc": "Patient Visit           - previous result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PV2",
                                                            "desc": "Patient Visit Add. Info - previous result",
                                                            "min": 0,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Patient Visit Prior)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "AL1",
                                                    "desc": "Allergy Information     - previous result",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_PRIOR",
                                                    "desc": "Order Prior",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "ORC",
                                                            "desc": "Common Order            - previous result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "OBR",
                                                            "desc": "Order Detail            - previous result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes and Comments      - previous result",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Order Prior)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "TIMING_PRIOR",
                                                            "desc": "Timing Prior",
                                                            "min": 0,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "TQ1",
                                                                    "desc": "Timing/Quantity",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "TQ2",
                                                                    "desc": "Timing/Quantity Order Sequence",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "OBSERVATION_PRIOR",
                                                            "desc": "Observation Prior",
                                                            "min": 1,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "OBX",
                                                                    "desc": "Observation/Result      - previous result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "PRT",
                                                                    "desc": "Participation (for Observation Prior)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "NTE",
                                                                    "desc": "Notes and Comments      - previous result",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "FT1",
                                    "desc": "Financial Transaction",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "CTI",
                                    "desc": "Clinical Trial Identification",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "BLG",
                                    "desc": "Billing Segment",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "OML_O35": {
        "desc": "Laboratory Order - Multiple Order Per Container of Specimen Message",
        "name": "OML_O35",
        "segments": {
            "desc": "Laboratory Order - Multiple Order Per Container of Specimen Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit- Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "SPECIMEN",
                    "desc": "Specimen",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SPM",
                            "desc": "Specimen",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPECIMEN_OBSERVATION",
                            "desc": "Specimen Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observations related to specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Speciment Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "SPECIMEN_CONTAINER",
                            "desc": "Specimen Container",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SAC",
                                    "desc": "Specimen Container",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBSERVATION_REQUEST",
                                            "desc": "Observation Request",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Request",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TCD",
                                                    "desc": "Test Code Details",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for Detail)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "DG1",
                                                    "desc": "Diagnosis",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "OBSERVATION",
                                                    "desc": "Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "TCD",
                                                            "desc": "Test Code Detail",
                                                            "min": 0,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes and Comments (for Results)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "PRIOR_RESULT",
                                                    "desc": "Prior Result",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "PATIENT_PRIOR",
                                                            "desc": "Patient Prior",
                                                            "min": 0,
                                                            "max": 1,
                                                            "children": [
                                                                {
                                                                    "name": "PID",
                                                                    "desc": "Patient Identification  - previous result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "PD1",
                                                                    "desc": "Additional Demographics - previous result",
                                                                    "min": 0,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "PRT",
                                                                    "desc": "Participation (for Patient Prior)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "PATIENT_VISIT_PRIOR",
                                                            "desc": "Patient Visit Prior",
                                                            "min": 0,
                                                            "max": 1,
                                                            "children": [
                                                                {
                                                                    "name": "PV1",
                                                                    "desc": "Patient Visit           - previous result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "PV2",
                                                                    "desc": "Patient Visit Add. Info - previous result",
                                                                    "min": 0,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "PRT",
                                                                    "desc": "Participation (for Patient Visit Prior)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "AL1",
                                                            "desc": "Allergy Information     - previous result",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "ORDER_PRIOR",
                                                            "desc": "Order Prior",
                                                            "min": 1,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "ORC",
                                                                    "desc": "Common Order            - previous result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "OBR",
                                                                    "desc": "Order Detail            - previous result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "NTE",
                                                                    "desc": "Notes and Comments      - previous result",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "PRT",
                                                                    "desc": "Participation (for Order Prior)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "TIMING_PRIOR",
                                                                    "desc": "Timing Prior",
                                                                    "min": 0,
                                                                    "max": 0,
                                                                    "children": [
                                                                        {
                                                                            "name": "TQ1",
                                                                            "desc": "Timing/Quantity",
                                                                            "min": 1,
                                                                            "max": 1
                                                                        },
                                                                        {
                                                                            "name": "TQ2",
                                                                            "desc": "Timing/Quantity Order Sequence",
                                                                            "min": 0,
                                                                            "max": 0
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "name": "OBSERVATION_PRIOR",
                                                                    "desc": "Observation Prior",
                                                                    "min": 1,
                                                                    "max": 0,
                                                                    "children": [
                                                                        {
                                                                            "name": "OBX",
                                                                            "desc": "Observation/Result      - previous result",
                                                                            "min": 1,
                                                                            "max": 1
                                                                        },
                                                                        {
                                                                            "name": "PRT",
                                                                            "desc": "Participation (for Observation Prior)",
                                                                            "min": 0,
                                                                            "max": 0
                                                                        },
                                                                        {
                                                                            "name": "NTE",
                                                                            "desc": "Notes and Comments      - previous result",
                                                                            "min": 0,
                                                                            "max": 0
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "name": "FT1",
                                            "desc": "Financial Transaction",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "CTI",
                                            "desc": "Clinical Trial Identification",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "BLG",
                                            "desc": "Billing Segment",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "OML_O39": {
        "desc": "Specimen Shipment Centric Laboratory Order Message",
        "name": "OML_O39",
        "segments": {
            "desc": "Specimen Shipment Centric Laboratory Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit- Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION_REQUEST",
                            "desc": "Observation Request",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OBR",
                                    "desc": "Observation Request",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TCD",
                                    "desc": "Test Code Details",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Detail)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TCD",
                                            "desc": "Test Code Detail",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for Results)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "SPECIMEN_SHIPMENT",
                                    "desc": "Specimen Shipment",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SHP",
                                            "desc": "Shipment Segment",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "SHIPMENT_OBSERVATION",
                                            "desc": "Shipment Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result Segment (Additional Shipping Information)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for OBX)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PACKAGE",
                                            "desc": "Package",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PAC",
                                                    "desc": "Shipping Package Segment",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "SPECIMEN_IN_PACKAGE",
                                                    "desc": "Specimen In Package",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "SPM",
                                                            "desc": "Specimen Information",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "SPECIMEN_OBSERVATION",
                                                            "desc": "Specimen Observation",
                                                            "min": 0,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "OBX",
                                                                    "desc": "Observation/Result Segment (For Specimen)",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "PRT",
                                                                    "desc": "Participation (for Specimen Observation)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "SPECIMEN_CONTAINER_IN_PACKAGE",
                                                            "desc": "Specimen Container In Package",
                                                            "min": 0,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "SAC",
                                                                    "desc": "Container Information",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "CONTAINER_OBSERVATION",
                                                                    "desc": "Container Observation",
                                                                    "min": 0,
                                                                    "max": 0,
                                                                    "children": [
                                                                        {
                                                                            "name": "OBX",
                                                                            "desc": "Observation/Result Segment (For Container)",
                                                                            "min": 1,
                                                                            "max": 1
                                                                        },
                                                                        {
                                                                            "name": "PRT",
                                                                            "desc": "Participation (for Container Observation)",
                                                                            "min": 0,
                                                                            "max": 0
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OMN_O07": {
        "desc": "Nonstock Requisition Order Message",
        "name": "OMN_O07",
        "segments": {
            "desc": "Nonstock Requisition Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RQD",
                            "desc": "Requisition Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RQ1",
                            "desc": "Requisition Detail-1",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for RQD)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for OBX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OMP_O09": {
        "desc": "Pharmacy/treatment Order Message",
        "name": "OMP_O09",
        "segments": {
            "desc": "Pharmacy/treatment Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ADDITIONAL_DEMOGRAPHICS",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Additional Demographics)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RXO",
                            "desc": "Pharmacy/Treatment Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for RXO)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RXR",
                            "desc": "Pharmacy/Treatment Route",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "COMPONENT",
                            "desc": "Component",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for each RXC)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for OBX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OMS_O05": {
        "desc": "Stock Requisition Order Message",
        "name": "OMS_O05",
        "segments": {
            "desc": "Stock Requisition Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RQD",
                            "desc": "Requisition Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RQ1",
                            "desc": "Requisition Detail-1",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for RQD)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for OBX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OPL_O37": {
        "desc": "Population/Location-Based Laboratory Order Message",
        "name": "OPL_O37",
        "segments": {
            "desc": "Population/Location-Based Laboratory Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PRT",
                    "desc": "Participation",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "GUARANTOR",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Guarantor)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Patient Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATIONS_ON_PATIENT",
                                    "desc": "Observations On Patient",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observations on the Patient",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observations on Patient)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "INSURANCE",
                                    "desc": "Insurance",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "IN1",
                                            "desc": "Insurance",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "IN2",
                                            "desc": "Insurance Additional Information",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "IN3",
                                            "desc": "Insurance Additional Information, Certification",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                },
                                {
                                    "name": "AL1",
                                    "desc": "Allergy Information",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPECIMEN_OBSERVATION",
                                    "desc": "Specimen Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result related to specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Specimen Observation)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "CONTAINER",
                                    "desc": "Container",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SAC",
                                            "desc": "Specimen Container",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "CONTAINER_OBSERVATION",
                                            "desc": "Container Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result related to container",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Containter Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "OBSERVATION_REQUEST",
                                    "desc": "Observation Request",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "OBR",
                                            "desc": "Observation Request",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation Request)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "TCD",
                                            "desc": "Test Code Details",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "DG1",
                                            "desc": "Diagnosis",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_RELATED_OBSERVATION",
                                            "desc": "Order Related Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result Related to Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Order Related Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRIOR_RESULT",
                            "desc": "Prior Result",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "NK1",
                                    "desc": "Next of Kin/Associated Parties",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "PATIENT_PRIOR",
                                    "desc": "Patient Prior",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PID",
                                            "desc": "Patient",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PD1",
                                            "desc": "Patient Additional Demographics",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Patient Prior)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PATIENT_VISIT_PRIOR",
                                    "desc": "Patient Visit Prior",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PV1",
                                            "desc": "Patient Visit",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PV2",
                                            "desc": "Patient Visit - Additional Information",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Patient Visit Prior)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "AL1",
                                    "desc": "Patient Allergy Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_PRIOR",
                                    "desc": "Order Prior",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Observation Request",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORC",
                                            "desc": "COMMON_ORDER",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Order Prior)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Relationship",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "Observation/Result_Group",
                                            "desc": "Observation/result Group",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result for prior order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "OPR_O38": {
        "desc": "Population/Location-Based Laboratory Order Acknowledgment Message",
        "name": "OPR_O38",
        "segments": {
            "desc": "Population/Location-Based Laboratory Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "NK1",
                                    "desc": "Next of Kin",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "SPECIMEN",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SPM",
                                            "desc": "Specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "SPECIMEN_OBSERVATION",
                                            "desc": "Specimen Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observations related to specimen",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Specimen Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "SAC",
                                            "desc": "Specimen Container",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "OBSERVATION_REQUEST",
                                            "desc": "Observation Request",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "Common Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Request",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation Request)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "OPU_R25": {
        "desc": "Unsolicited Population/Location-Based Laboratory Observation Message",
        "name": "OPU_R25",
        "segments": {
            "desc": "Unsolicited Population/Location-Based Laboratory Observation Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PV1",
                    "desc": "Patient Visit",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PV2",
                    "desc": "Patient Visit - Additional Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Patient Visit)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT_VISIT_OBSERVATION",
                    "desc": "Patient Visit Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation on the Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments on Visit",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ACCESSION_DETAIL",
                    "desc": "Accession Detail",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "NK1",
                            "desc": "Next of Kin",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PATIENT_OBSERVATION",
                                    "desc": "Patient Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observations on Patient",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation on Patient)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for Observation on Patient",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPECIMEN_OBSERVATION",
                                    "desc": "Specimen Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation on Specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for Observation on Specimen",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "CONTAINER",
                                    "desc": "Container",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SAC",
                                            "desc": "Container information",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "INV",
                                            "desc": "Detailed Substance information (e.g., id, lot, manufacturer, ... of QC specimen)",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Observation Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORC",
                                            "desc": "COMMON_ORDER",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for Detail)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING_QTY",
                                            "desc": "Timing Qty",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RESULT",
                                            "desc": "Result",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORA_R33": {
        "desc": "Observation Report Acknowledgement",
        "name": "ORA_R33",
        "segments": {
            "desc": "Observation Report Acknowledgement",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORC",
                    "desc": "COMMON_ORDER Information",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ORB_O28": {
        "desc": "Description",
        "name": "ORB_O28",
        "segments": {
            "desc": "Description",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Response Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "BPO",
                                            "desc": "Blood Product Order",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORD_O04": {
        "desc": "Dietary Order Acknowledgment Message",
        "name": "ORD_O04",
        "segments": {
            "desc": "Dietary Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for MSA)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_DIET",
                            "desc": "Order Diet",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING_DIET",
                                    "desc": "Timing Diet",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ODS",
                                    "desc": "Dietary Orders, Supplements, and Preferences",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for ODS)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_TRAY",
                            "desc": "Order Tray",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING_TRAY",
                                    "desc": "Timing Tray",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ODT",
                                    "desc": "Diet Tray Instructions",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for ODT)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORG_O20": {
        "desc": "General Clinical Order Acknowledgment Message",
        "name": "ORG_O20",
        "segments": {
            "desc": "General Clinical Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBSERVATION_GROUP",
                                    "desc": "Observation Group",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Observation",
                                            "min": 1,
                                            "max": 1
                                        }
                                    ]
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Detail)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "CTI",
                                    "desc": "Clinical Trial Identification",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "SPECIMEN",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SPM",
                                            "desc": "Specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "SAC",
                                            "desc": "Specimen Container Details",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORI_O24": {
        "desc": "Imaging Order Acknowledgment Message",
        "name": "ORI_O24",
        "segments": {
            "desc": "Imaging Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBR",
                                    "desc": "Observation",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Detail)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "IPC",
                                    "desc": "Imaging Procedure Control",
                                    "min": 1,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORL_O22": {
        "desc": "General Laboratory Order Acknowledgment Message",
        "name": "ORL_O22",
        "segments": {
            "desc": "General Laboratory Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for COMMON_ORDER)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBSERVATION_REQUEST",
                                    "desc": "Observation Request",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Observation Request",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation Request)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "SPECIMEN",
                                            "desc": "Specimen",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "SPM",
                                                    "desc": "Specimen",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "SAC",
                                                    "desc": "Specimen Container Details",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORL_O34": {
        "desc": "Laboratory Order Acknowledgment Message  - Multiple Order Per Specimen",
        "name": "ORL_O34",
        "segments": {
            "desc": "Laboratory Order Acknowledgment Message  - Multiple Order Per Specimen",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPECIMEN_OBSERVATION",
                                    "desc": "Specimen Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observations related to specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Specimen Observation)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "SAC",
                                    "desc": "Specimen Container",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBSERVATION_REQUEST",
                                            "desc": "Observation Request",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Request",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORL_O36": {
        "desc": "Laboratory Order Acknowledgment Message  - Multiple Order Per Container of Specimen",
        "name": "ORL_O36",
        "segments": {
            "desc": "Laboratory Order Acknowledgment Message  - Multiple Order Per Container of Specimen",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPECIMEN_OBSERVATION",
                                    "desc": "Specimen Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observations related to specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Specimen Related Observation)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for specimen)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "SPECIMEN_CONTAINER",
                                    "desc": "Specimen Container",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SAC",
                                            "desc": "Specimen Container",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER",
                                            "desc": "Order",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "Common Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING",
                                                    "desc": "Timing",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "OBSERVATION_REQUEST",
                                                    "desc": "Observation Request",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "Observation Request",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation Request)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORL_O40": {
        "desc": "Specimen Shipment Centric Laboratory Order Acknowledgment Message",
        "name": "ORL_O40",
        "segments": {
            "desc": "Specimen Shipment Centric Laboratory Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING",
                                            "desc": "Timing",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "OBSERVATION_REQUEST",
                                            "desc": "Observation Request",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "Observation Request",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation Request)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "SPECIMEN_SHIPMENT",
                                                    "desc": "Specimen Shipment",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "SHP",
                                                            "desc": "Shipment Segment",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PACKAGE",
                                                            "desc": "Package",
                                                            "min": 1,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "PAC",
                                                                    "desc": "Shipping Package Segment",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "SPECIMEN_IN_PACKAGE",
                                                                    "desc": "Specimen In Package",
                                                                    "min": 0,
                                                                    "max": 0,
                                                                    "children": [
                                                                        {
                                                                            "name": "SPM",
                                                                            "desc": "Specimen Information",
                                                                            "min": 1,
                                                                            "max": 1
                                                                        },
                                                                        {
                                                                            "name": "SPECIMEN_CONTAINER_IN_PACKAGE",
                                                                            "desc": "Specimen Container In Package",
                                                                            "min": 0,
                                                                            "max": 0,
                                                                            "children": [
                                                                                {
                                                                                    "name": "SAC",
                                                                                    "desc": "Container Information",
                                                                                    "min": 1,
                                                                                    "max": 1
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORN_O08": {
        "desc": "General Order Acknowledgment Message",
        "name": "ORN_O08",
        "segments": {
            "desc": "General Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RQD",
                                    "desc": "Requisition Detail",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RQ1",
                                    "desc": "Requisition Detail-1",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RQD)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORP_O10": {
        "desc": "Description",
        "name": "ORP_O10",
        "segments": {
            "desc": "Description",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Response Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for ORC)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXO",
                                            "desc": "Pharmacy/Treatment Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for RXO)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "COMPONENT",
                                            "desc": "Component",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for each RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORS_O06": {
        "desc": "Stock Order Acknowledgment Message",
        "name": "ORS_O06",
        "segments": {
            "desc": "Stock Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RQD",
                                    "desc": "Requisition Detail",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RQ1",
                                    "desc": "Requisition Detail-1",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RQD)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "ORU_R01": {
        "desc": "Observation Message",
        "name": "ORU_R01",
        "segments": {
            "desc": "Observation Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT_RESULT",
                    "desc": "Patient Result",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NK1",
                                    "desc": "Next of Kin/Associated Parties",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PATIENT_OBSERVATION",
                                    "desc": "Patient Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation (for Patient ID)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (Observation Participation)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "VISIT",
                                    "desc": "Visit",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PV1",
                                            "desc": "Patient Visit",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PV2",
                                            "desc": "Patient Visit - Additional Info",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Patient Visit)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER_OBSERVATION",
                            "desc": "Order Observation",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Order common",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "OBR",
                                    "desc": "Observations Request",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and comments",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING_QTY",
                                    "desc": "Timing Qty",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation related to OBR",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (Observation Participation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and comments",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "FT1",
                                    "desc": "Financial Transaction",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "CTI",
                                    "desc": "Clinical Trial Identification",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "SPECIMEN",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SPM",
                                            "desc": "Specimen",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "SPECIMEN_OBSERVATION",
                                            "desc": "Specimen Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation (for Patient ID)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (Observation Participation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "ORU_R30": {
        "desc": "Unsolicited Point-Of-Care Observation Message without Existing Order - Place an Order",
        "name": "ORU_R30",
        "segments": {
            "desc": "Unsolicited Point-Of-Care Observation Message without Existing Order - Place an Order",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Patient)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT_OBSERVATION",
                    "desc": "Patient Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation (for Patient ID)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Observation)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient Visit)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORC",
                    "desc": "Common Order information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "OBR",
                    "desc": "Observation Request",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes or Comments for order/result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for observation)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "TIMING_QTY",
                    "desc": "Timing Qty",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ2",
                            "desc": "Timing/Quantity Order Sequence",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation Results, one per reported value",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Observation)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes or Comments for individual result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "ORU_R31": {
        "desc": "Unsolicited New Point-Of-Care Observation Message - Search for an Order",
        "name": "ORU_R31",
        "segments": {
            "desc": "Unsolicited New Point-Of-Care Observation Message - Search for an Order",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Patient)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT_OBSERVATION",
                    "desc": "Patient Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation (for Patient ID)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Observation)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient Visit)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORC",
                    "desc": "Common Order information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "OBR",
                    "desc": "Observation Request",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes or Comments for order/result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for observation)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "TIMING_QTY",
                    "desc": "Timing Qty",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ2",
                            "desc": "Timing/Quantity Order Sequence",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation Results, one per reported value",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Observation Results)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes or Comments for individual result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "ORU_R32": {
        "desc": "Unsolicited Pre-Ordered Point-Of-Care Observation",
        "name": "ORU_R32",
        "segments": {
            "desc": "Unsolicited Pre-Ordered Point-Of-Care Observation",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Patient)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT_OBSERVATION",
                    "desc": "Patient Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation (for Patient ID)",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Observation)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient Visit)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORC",
                    "desc": "Common Order information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "OBR",
                    "desc": "Observation Request",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes or Comments for order/result",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Observation Request)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "TIMING_QTY",
                    "desc": "Timing Qty",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ2",
                            "desc": "Timing/Quantity Order Sequence",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBX",
                            "desc": "Observation Results, one per reported value",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Observation Results)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes or Comments for individual result",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "OSM_R26": {
        "desc": "Unsolicited Specimen Shipment Manifest Message",
        "name": "OSM_R26",
        "segments": {
            "desc": "Unsolicited Specimen Shipment Manifest Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SHIPMENT",
                    "desc": "Shipment",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SHP",
                            "desc": "Shipment Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Shipment)",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "SHIPPING_OBSERVATION",
                            "desc": "Shipping Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result Segment (Additional Shipping Information)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Shipping Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PACKAGE",
                            "desc": "Package",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PAC",
                                    "desc": "Shipping Package Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Shipping Package)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "SPECIMEN",
                                    "desc": "Specimen",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SPM",
                                            "desc": "Specimen Information",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Specimen)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "SPECIMEN_OBSERVATION",
                                            "desc": "Specimen Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result Segment (For Specimen)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Specimen Observation)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "CONTAINER",
                                            "desc": "Container",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "SAC",
                                                    "desc": "Container Information",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "CONTAINER_OBSERVATION",
                                                    "desc": "Container Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result Segment (For Container)",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "name": "SUBJECT_PERSON/ANIMAL_IDENTIFICATION",
                                            "desc": "Subject Person/animal Identification",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "PID",
                                                    "desc": "Patient Identification (For Person/Animal)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Patient)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "PATIENT_OBSERVATION",
                                                    "desc": "Patient Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result Segment (For Patient)",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NK1",
                                                    "desc": "Next of Kin/Associated Parties (For Person/Animal)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "SUBJECT_POPULATION/LOCATION_IDENTIFICATION",
                                            "desc": "Subject Population/location Identification",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "PV1",
                                                    "desc": "Patient Visit (For Population/Location)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Patient Visit)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "PATIENT_VISIT_OBSERVATION",
                                                    "desc": "Patient Visit Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result Segment (For Visit)",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Patient Visit Observation)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "PID",
                                                    "desc": "Patient Identification (For Population)",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Patient)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "NK1",
                                                    "desc": "Next of Kin/Associated Parties (For Population/Location)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "OUL_R22": {
        "desc": "Unsolicited Specimen Oriented Observation Message",
        "name": "OUL_R22",
        "segments": {
            "desc": "Unsolicited Specimen Oriented Observation Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_OBSERVATION",
                            "desc": "Patient Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation (for Patient ID)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SPECIMEN",
                    "desc": "Specimen",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SPM",
                            "desc": "Specimen information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPECIMEN_OBSERVATION",
                            "desc": "Specimen Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation Result (for Specimen)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Specimen Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CONTAINER",
                            "desc": "Container",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SAC",
                                    "desc": "Container information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "INV",
                                    "desc": "Detailed Substance information (e.g., id, lot, manufacturer, ... of QC specimen)",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBR",
                                    "desc": "Observation Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORC",
                                    "desc": "COMMON_ORDER",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Detail)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING_QTY",
                                    "desc": "Timing Qty",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RESULT",
                                    "desc": "Result",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation Result)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TCD",
                                            "desc": "Test Code Detail",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "SID",
                                            "desc": "Substance Identifier (e.g., reagents used for testing)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "CTI",
                                    "desc": "Clinical Trial Identification",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "OUL_R23": {
        "desc": "Unsolicited Specimen Container Oriented Observation Message",
        "name": "OUL_R23",
        "segments": {
            "desc": "Unsolicited Specimen Container Oriented Observation Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_OBSERVATION",
                            "desc": "Patient Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation (for Patient ID)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SPECIMEN",
                    "desc": "Specimen",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SPM",
                            "desc": "Specimen information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPECIMEN_OBSERVATION",
                            "desc": "Specimen Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation (for Specimen)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CONTAINER",
                            "desc": "Container",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SAC",
                                    "desc": "Container information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "INV",
                                    "desc": "Detailed Substance information (e.g., id, lot, manufacturer, ... of QC specimen)",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBR",
                                            "desc": "Observation Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORC",
                                            "desc": "COMMON_ORDER",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for Detail)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING_QTY",
                                            "desc": "Timing Qty",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RESULT",
                                            "desc": "Result",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TCD",
                                                    "desc": "Test Code Detail",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "SID",
                                                    "desc": "Substance Identifier (e.g., reagents used for testing)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "CTI",
                                            "desc": "Clinical Trial Identification",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "OUL_R24": {
        "desc": "Unsolicited Order Oriented Observation Message",
        "name": "OUL_R24",
        "segments": {
            "desc": "Unsolicited Order Oriented Observation Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_OBSERVATION",
                            "desc": "Patient Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation (for Patient ID)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "VISIT",
                            "desc": "Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ORC",
                            "desc": "COMMON_ORDER",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Detail)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for observation)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "TIMING_QTY",
                            "desc": "Timing Qty",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SPECIMEN_OBSERVATION",
                                    "desc": "Specimen Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation (for Specimen)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "CONTAINER",
                                    "desc": "Container",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "SAC",
                                            "desc": "Container information",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "INV",
                                            "desc": "Detailed Substance information (e.g., id, lot, manufacturer, ... of QC specimen)",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "RESULT",
                            "desc": "Result",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TCD",
                                    "desc": "Test Code Detail",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "SID",
                                    "desc": "Substance Identifier (e.g., reagents used for testing)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "PEX_P07": {
        "desc": "Unsolicited initial individual product experience report",
        "name": "PEX_P07",
        "segments": {
            "desc": "Unsolicited initial individual product experience report",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Patient)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and comments",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient Visit)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "EXPERIENCE",
                    "desc": "Experience",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PES",
                            "desc": "Product Experience Sender",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PEX_OBSERVATION",
                            "desc": "Pex Observation",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PEO",
                                    "desc": "Product Experience Observation",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PEX_CAUSE",
                                    "desc": "Pex Cause",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PCR",
                                            "desc": "Potential Causal Relationship",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RX_ORDER",
                                            "desc": "Rx Order",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "RXE",
                                                    "desc": "Pharmacy/Treatment Encoded Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Pharmacy/Treatment)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_QTY",
                                                    "desc": "Timing Qty",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "RXR",
                                                    "desc": "Pharmacy/Treatment Route",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RX_ADMINISTRATION",
                                            "desc": "Rx Administration",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXA",
                                                    "desc": "Pharmacy/Treatment Administration",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "RXR",
                                                    "desc": "Pharmacy/Treatment Route",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Pharmacy Administration)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PRB",
                                            "desc": "Detail problem segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "OBSERVATION",
                                            "desc": "Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result Segment",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and comments",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ASSOCIATED_PERSON",
                                            "desc": "Associated Person",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "NK1",
                                                    "desc": "Associated parties segment",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ASSOCIATED_RX_ORDER",
                                                    "desc": "Associated Rx Order",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "RXE",
                                                            "desc": "Pharmacy/Treatment Encoded Order",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy/Treatment)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "NK1_TIMING_QTY",
                                                            "desc": "Nk1 Timing Qty",
                                                            "min": 1,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "TQ1",
                                                                    "desc": "Timing/Quantity",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "TQ2",
                                                                    "desc": "Timing/Quantity Order Sequence",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy/Treatment Route",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "ASSOCIATED_RX_ADMIN",
                                                    "desc": "Associated Rx Admin",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "RXA",
                                                            "desc": "Pharmacy/Treatment Administration",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy/Treatment Route",
                                                            "min": 0,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy Administration)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "PRB",
                                                    "desc": "Detail Problem Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ASSOCIATED_OBSERVATION",
                                                    "desc": "Associated Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Results Segment",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "name": "STUDY",
                                            "desc": "Study",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "CSR",
                                                    "desc": "Clinical study registration",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "CSP",
                                                    "desc": "Clinical study phase segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PEX_P08": {
        "desc": "Unsolicited update individual product experience report",
        "name": "PEX_P08",
        "segments": {
            "desc": "Unsolicited update individual product experience report",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PRT",
                    "desc": "Participation (for Patient)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and comments",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient Visit)",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "EXPERIENCE",
                    "desc": "Experience",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PES",
                            "desc": "Product Experience Sender",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PEX_OBSERVATION",
                            "desc": "Pex Observation",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PEO",
                                    "desc": "Product Experience Observation",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PEX_CAUSE",
                                    "desc": "Pex Cause",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PCR",
                                            "desc": "Potential Causal Relationship",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RX_ORDER",
                                            "desc": "Rx Order",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "RXE",
                                                    "desc": "Pharmacy/Treatment Encoded Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Pharmacy/Treatment)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "TIMING_QTY",
                                                    "desc": "Timing Qty",
                                                    "min": 1,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "TQ1",
                                                            "desc": "Timing/Quantity",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "TQ2",
                                                            "desc": "Timing/Quantity Order Sequence",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "RXR",
                                                    "desc": "Pharmacy/Treatment Route",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RX_ADMINISTRATION",
                                            "desc": "Rx Administration",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXA",
                                                    "desc": "Pharmacy/Treatment Administration",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "RXR",
                                                    "desc": "Pharmacy/Treatment Route",
                                                    "min": 0,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Pharmacy Administration)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PRB",
                                            "desc": "Detail problem segment",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "OBSERVATION",
                                            "desc": "Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result Segment",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Observation Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and comments",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ASSOCIATED_PERSON",
                                            "desc": "Associated Person",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "NK1",
                                                    "desc": "Associated parties segment",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ASSOCIATED_RX_ORDER",
                                                    "desc": "Associated Rx Order",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "RXE",
                                                            "desc": "Pharmacy/Treatment Encoded Order",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy/Treatment)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "NK1_TIMING_QTY",
                                                            "desc": "Nk1 Timing Qty",
                                                            "min": 1,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "TQ1",
                                                                    "desc": "Timing/Quantity",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "TQ2",
                                                                    "desc": "Timing/Quantity Order Sequence",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy/Treatment Route",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "ASSOCIATED_RX_ADMIN",
                                                    "desc": "Associated Rx Admin",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "RXA",
                                                            "desc": "Pharmacy/Treatment Administration",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "RXR",
                                                            "desc": "Pharmacy/Treatment Route",
                                                            "min": 0,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Pharmacy Administration)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "PRB",
                                                    "desc": "Detail Problem Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ASSOCIATED_OBSERVATION",
                                                    "desc": "Associated Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Results Segment",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "PRT",
                                                            "desc": "Participation (for Observation Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "name": "STUDY",
                                            "desc": "Study",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "CSR",
                                                    "desc": "Clinical study registration",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "CSP",
                                                    "desc": "Clinical study phase segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PGL_PC6": {
        "desc": "Patient Goal Message",
        "name": "PGL_PC6",
        "segments": {
            "desc": "Patient Goal Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Detail Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "GOAL_ROLE",
                            "desc": "Goal Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Goal)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Detail Pathway",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR,RXO,RXE",
                                            "desc": "Choice",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "OBR Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXO",
                                                    "desc": "RXO Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXE",
                                                    "desc": "RXE Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes (Order Detail Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_OBSERVATION",
                                            "desc": "Order Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PGL_PC7": {
        "desc": "Patient Goal Message",
        "name": "PGL_PC7",
        "segments": {
            "desc": "Patient Goal Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Detail Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "GOAL_ROLE",
                            "desc": "Goal Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Goal)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Detail Pathway",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR,RXO,RXE",
                                            "desc": "Choice",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "OBR Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXO",
                                                    "desc": "RXO Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXE",
                                                    "desc": "RXE Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes (Order Detail Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_OBSERVATION",
                                            "desc": "Order Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PGL_PC8": {
        "desc": "Patient Goal Message",
        "name": "PGL_PC8",
        "segments": {
            "desc": "Patient Goal Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "GOAL",
                    "desc": "Goal",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "GOL",
                            "desc": "Detail Goal",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Goal)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "GOAL_ROLE",
                            "desc": "Goal Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Goal)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Detail Pathway",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR,RXO,RXE",
                                            "desc": "Choice",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "OBR Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXO",
                                                    "desc": "RXO Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXE",
                                                    "desc": "RXE Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes (Order Detail Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_OBSERVATION",
                                            "desc": "Order Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PIN_I07": {
        "desc": "Patient Insurance Information",
        "name": "PIN_I07",
        "segments": {
            "desc": "Patient Insurance Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info -Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PMU_B01": {
        "desc": "Personnel Record Message",
        "name": "PMU_B01",
        "segments": {
            "desc": "Personnel Record Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORG",
                    "desc": "Organization",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AFF",
                    "desc": "Affiliation",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "LAN",
                    "desc": "Language",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "EDU",
                    "desc": "Education",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "CER",
                    "desc": "Certificate",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PMU_B02": {
        "desc": "Personnel Record Message",
        "name": "PMU_B02",
        "segments": {
            "desc": "Personnel Record Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORG",
                    "desc": "Organization",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AFF",
                    "desc": "Affiliation",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "LAN",
                    "desc": "Language",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "EDU",
                    "desc": "Education",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "CER",
                    "desc": "Certificate",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ROL",
                    "desc": "Role",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PMU_B03": {
        "desc": "Delete Personnel Record Message",
        "name": "PMU_B03",
        "segments": {
            "desc": "Delete Personnel Record Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "PMU_B04": {
        "desc": "Activate Practicing Person Message",
        "name": "PMU_B04",
        "segments": {
            "desc": "Activate Practicing Person Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORG",
                    "desc": "Organization",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PMU_B05": {
        "desc": "Deactivate Practicing Person Message",
        "name": "PMU_B05",
        "segments": {
            "desc": "Deactivate Practicing Person Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORG",
                    "desc": "Organization",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PMU_B06": {
        "desc": "Terminate Practicing Person Message",
        "name": "PMU_B06",
        "segments": {
            "desc": "Terminate Practicing Person Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "ORG",
                    "desc": "Organization",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PMU_B07": {
        "desc": "Grant Certificate Message",
        "name": "PMU_B07",
        "segments": {
            "desc": "Grant Certificate Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "CERTIFICATE",
                    "desc": "Certificate",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "CER",
                            "desc": "Certificate",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "PMU_B08": {
        "desc": "Revoke Certificate Message",
        "name": "PMU_B08",
        "segments": {
            "desc": "Revoke Certificate Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EVN",
                    "desc": "Event Type",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PRA",
                    "desc": "Practitioner",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "CER",
                    "desc": "Certificate",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "PPG_PCG": {
        "desc": "Patient Pathway Goal-Oriented Message",
        "name": "PPG_PCG",
        "segments": {
            "desc": "Patient Pathway Goal-Oriented Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments(Pathway Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATHWAY_ROLE",
                            "desc": "Pathway Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Pathway)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments(Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM",
                                    "desc": "Problem",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PRB",
                                            "desc": "Detail Problem",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Problem Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Problem)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PROBLEM_ROLE",
                                            "desc": "Problem Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Problem)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROBLEM_OBSERVATION",
                                            "desc": "Problem Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments(Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments(Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPG_PCH": {
        "desc": "Patient Pathway Goal-Oriented Message",
        "name": "PPG_PCH",
        "segments": {
            "desc": "Patient Pathway Goal-Oriented Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments(Pathway Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATHWAY_ROLE",
                            "desc": "Pathway Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Pathway)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments(Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM",
                                    "desc": "Problem",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PRB",
                                            "desc": "Detail Problem",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Problem Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Problem)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PROBLEM_ROLE",
                                            "desc": "Problem Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Problem)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROBLEM_OBSERVATION",
                                            "desc": "Problem Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments(Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments(Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPG_PCJ": {
        "desc": "Patient Pathway Goal-Oriented Message",
        "name": "PPG_PCJ",
        "segments": {
            "desc": "Patient Pathway Goal-Oriented Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments(Pathway Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATHWAY_ROLE",
                            "desc": "Pathway Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Pathway)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments(Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM",
                                    "desc": "Problem",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PRB",
                                            "desc": "Detail Problem",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Problem Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Problem)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PROBLEM_ROLE",
                                            "desc": "Problem Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Problem)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROBLEM_OBSERVATION",
                                            "desc": "Problem Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments(Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments(Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPP_PCB": {
        "desc": "Patient Pathway Problem-Oriented Message",
        "name": "PPP_PCB",
        "segments": {
            "desc": "Patient Pathway Problem-Oriented Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments(Pathway Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATHWAY_ROLE",
                            "desc": "Pathway Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Pathway)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments(Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL",
                                    "desc": "Goal",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "GOL",
                                            "desc": "Detail Goal",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Goal Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Goal)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "GOAL_ROLE",
                                            "desc": "Goal Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Goal)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "GOAL_OBSERVATION",
                                            "desc": "Goal Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments(Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments(Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPP_PCC": {
        "desc": "Patient Pathway Problem-Oriented Message",
        "name": "PPP_PCC",
        "segments": {
            "desc": "Patient Pathway Problem-Oriented Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments(Pathway Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATHWAY_ROLE",
                            "desc": "Pathway Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Pathway)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments(Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL",
                                    "desc": "Goal",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "GOL",
                                            "desc": "Detail Goal",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Goal Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Goal)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "GOAL_ROLE",
                                            "desc": "Goal Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Goal)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "GOAL_OBSERVATION",
                                            "desc": "Goal Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments(Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments(Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPP_PCD": {
        "desc": "Patient Pathway Problem-Oriented Message",
        "name": "PPP_PCD",
        "segments": {
            "desc": "Patient Pathway Problem-Oriented Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PATHWAY",
                    "desc": "Pathway",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PTH",
                            "desc": "Pathway Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments(Pathway Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Pathway)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATHWAY_ROLE",
                            "desc": "Pathway Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Pathway)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments(Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL",
                                    "desc": "Goal",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "GOL",
                                            "desc": "Detail Goal",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments(Goal Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Goal)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "GOAL_ROLE",
                                            "desc": "Goal Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Goal)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "GOAL_OBSERVATION",
                                            "desc": "Goal Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments(Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments(Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPR_PC1": {
        "desc": "Patient Problem Message",
        "name": "PPR_PC1",
        "segments": {
            "desc": "Patient Problem Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Detail Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments (Problem Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PROBLEM_ROLE",
                            "desc": "Problem Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Problem)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Detail Pathway",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM_OBSERVATION",
                            "desc": "Problem Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR,RXO,RXE",
                                            "desc": "Choice",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "OBR Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXO",
                                                    "desc": "RXO Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXE",
                                                    "desc": "RXE Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Order Detail Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_OBSERVATION",
                                            "desc": "Order Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPR_PC2": {
        "desc": "Patient Problem Message",
        "name": "PPR_PC2",
        "segments": {
            "desc": "Patient Problem Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Detail Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments (Problem Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PROBLEM_ROLE",
                            "desc": "Problem Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Problem)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Detail Pathway",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM_OBSERVATION",
                            "desc": "Problem Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR,RXO,RXE",
                                            "desc": "Choice",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "OBR Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXO",
                                                    "desc": "RXO Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXE",
                                                    "desc": "RXE Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Order Detail Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_OBSERVATION",
                                            "desc": "Order Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPR_PC3": {
        "desc": "Patient Problem Message",
        "name": "PPR_PC3",
        "segments": {
            "desc": "Patient Problem Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROBLEM",
                    "desc": "Problem",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRB",
                            "desc": "Detail Problem",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes & Comments (Problem Comments)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "VAR",
                            "desc": "Variance (Problem)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PROBLEM_ROLE",
                            "desc": "Problem Role",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ROL",
                                    "desc": "Role (Problem)",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Role)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Detail Pathway",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM_OBSERVATION",
                            "desc": "Problem Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "OBR,RXO,RXE",
                                            "desc": "Choice",
                                            "min": 0,
                                            "max": 0,
                                            "compounds": [
                                                {
                                                    "name": "OBR",
                                                    "desc": "OBR Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXO",
                                                    "desc": "RXO Segment",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "RXE",
                                                    "desc": "RXE Segment",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Order Detail Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Order)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "ORDER_OBSERVATION",
                                            "desc": "Order Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Observation/Result)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPT_PCL": {
        "desc": "Patient Pathway Goal-Oriented Response",
        "name": "PPT_PCL",
        "segments": {
            "desc": "Patient Pathway Goal-Oriented Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Pathway Detail",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Pathway Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PATHWAY_ROLE",
                                    "desc": "Pathway Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Pathway)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL",
                                    "desc": "Goal",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "GOL",
                                            "desc": "Detail Goal",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Goal Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Goal)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "GOAL_ROLE",
                                            "desc": "Goal Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Goal)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "GOAL_OBSERVATION",
                                            "desc": "Goal Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROBLEM",
                                            "desc": "Problem",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "PRB",
                                                    "desc": "Detail Problem",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Problem Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Problem)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "PROBLEM_ROLE",
                                                    "desc": "Problem Role",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "ROL",
                                                            "desc": "Role (Problem)",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Role)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "PROBLEM_OBSERVATION",
                                                    "desc": "Problem Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "name": "ORDER",
                                            "desc": "Order",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "Common Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ORDER_DETAIL",
                                                    "desc": "Order Detail",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "OBR,RXO,RXE",
                                                            "desc": "Choice",
                                                            "min": 0,
                                                            "max": 0,
                                                            "compounds": [
                                                                {
                                                                    "name": "OBR",
                                                                    "desc": "OBR Segment",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "RXO",
                                                                    "desc": "RXO Segment",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "RXE",
                                                                    "desc": "RXE Segment",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments (Order Detail Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Order)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "ORDER_OBSERVATION",
                                                            "desc": "Order Observation",
                                                            "min": 0,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "OBX",
                                                                    "desc": "Observation/Result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "NTE",
                                                                    "desc": "Notes & Comments (Observation Comments)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "VAR",
                                                                    "desc": "Variance (Observation/Result)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PPV_PCA": {
        "desc": "Goal Query Response",
        "name": "PPV_PCA",
        "segments": {
            "desc": "Goal Query Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GOAL",
                            "desc": "Goal",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "GOL",
                                    "desc": "Detail Goal",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Goal Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Goal)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "GOAL_ROLE",
                                    "desc": "Goal Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Goal)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_PATHWAY",
                                    "desc": "Goal Pathway",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PTH",
                                            "desc": "Detail Pathway",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Pathway)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL_OBSERVATION",
                                    "desc": "Goal Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM",
                                    "desc": "Problem",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PRB",
                                            "desc": "Detail Problem",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Problem Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Problem)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PROBLEM_ROLE",
                                            "desc": "Problem Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Problem)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROBLEM_OBSERVATION",
                                            "desc": "Problem Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments (Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PRR_PC5": {
        "desc": "Problem Query Response",
        "name": "PRR_PC5",
        "segments": {
            "desc": "Problem Query Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "PROBLEM",
                            "desc": "Problem",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PRB",
                                    "desc": "Detail Problem",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Problem Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Problem)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PROBLEM_ROLE",
                                    "desc": "Problem Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Problem)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_PATHWAY",
                                    "desc": "Problem Pathway",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PTH",
                                            "desc": "Detail Pathway",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Pathway)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM_OBSERVATION",
                                    "desc": "Problem Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GOAL",
                                    "desc": "Goal",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "GOL",
                                            "desc": "Detail Goal",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Goal Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Goal)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "GOAL_ROLE",
                                            "desc": "Goal Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Goal)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "GOAL_OBSERVATION",
                                            "desc": "Goal Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER",
                                    "desc": "Order",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ORC",
                                            "desc": "Common Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "ORDER_DETAIL",
                                            "desc": "Order Detail",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "OBR,RXO,RXE",
                                                    "desc": "Choice",
                                                    "min": 0,
                                                    "max": 0,
                                                    "compounds": [
                                                        {
                                                            "name": "OBR",
                                                            "desc": "OBR Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXO",
                                                            "desc": "RXO Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "RXE",
                                                            "desc": "RXE Segment",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Order Detail Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Order)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "ORDER_OBSERVATION",
                                                    "desc": "Order Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments (Observation Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Observation/Result)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "PTR_PCF": {
        "desc": "Patient Pathway Problem-Oriented Response",
        "name": "PTR_PCF",
        "segments": {
            "desc": "Patient Pathway Problem-Oriented Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "PATHWAY",
                            "desc": "Pathway",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PTH",
                                    "desc": "Pathway Detail",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes & Comments (Pathway Comments)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VAR",
                                    "desc": "Variance (Pathway)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PATHWAY_ROLE",
                                    "desc": "Pathway Role",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "ROL",
                                            "desc": "Role (Pathway)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Role)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PROBLEM",
                                    "desc": "Problem",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PRB",
                                            "desc": "Detail Problem",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes & Comments (Problem Comments)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "VAR",
                                            "desc": "Variance (Problem)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "PROBLEM_ROLE",
                                            "desc": "Problem Role",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ROL",
                                                    "desc": "Role (Problem)",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Role)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "PROBLEM_OBSERVATION",
                                            "desc": "Problem Observation",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "OBX",
                                                    "desc": "Observation/Result",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Observation/Result Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "GOAL",
                                            "desc": "Goal",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "GOL",
                                                    "desc": "Detail Goal",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes & Comments (Goal Comments)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "VAR",
                                                    "desc": "Variance (Goal)",
                                                    "min": 0,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "GOAL_ROLE",
                                                    "desc": "Goal Role",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "ROL",
                                                            "desc": "Role (Goal)",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Role)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "name": "GOAL_OBSERVATION",
                                                    "desc": "Goal Observation",
                                                    "min": 0,
                                                    "max": 0,
                                                    "children": [
                                                        {
                                                            "name": "OBX",
                                                            "desc": "Observation/Result",
                                                            "min": 1,
                                                            "max": 1
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments (Observation/Result Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "name": "ORDER",
                                            "desc": "Order",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "ORC",
                                                    "desc": "Common Order",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "ORDER_DETAIL",
                                                    "desc": "Order Detail",
                                                    "min": 0,
                                                    "max": 1,
                                                    "children": [
                                                        {
                                                            "name": "OBR,RXO,RXE",
                                                            "desc": "Choice",
                                                            "min": 0,
                                                            "max": 0,
                                                            "compounds": [
                                                                {
                                                                    "name": "OBR",
                                                                    "desc": "OBR Segment",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "RXO",
                                                                    "desc": "RXO Segment",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "RXE",
                                                                    "desc": "RXE Segment",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "name": "NTE",
                                                            "desc": "Notes & Comments (Order Detail Comments)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "VAR",
                                                            "desc": "Variance (Order)",
                                                            "min": 0,
                                                            "max": 0
                                                        },
                                                        {
                                                            "name": "ORDER_OBSERVATION",
                                                            "desc": "Order Observation",
                                                            "min": 0,
                                                            "max": 0,
                                                            "children": [
                                                                {
                                                                    "name": "OBX",
                                                                    "desc": "Observation/Result",
                                                                    "min": 1,
                                                                    "max": 1
                                                                },
                                                                {
                                                                    "name": "NTE",
                                                                    "desc": "Notes & Comments (Observation Comments)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                },
                                                                {
                                                                    "name": "VAR",
                                                                    "desc": "Variance (Observation/Result)",
                                                                    "min": 0,
                                                                    "max": 0
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "QBP_E03": {
        "desc": "Query HealthCare Services Invoice",
        "name": "QBP_E03",
        "segments": {
            "desc": "Query HealthCare Services Invoice",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Secondary Header",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QUERY_INFORMATION",
                    "desc": "Query Information",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "QPD",
                            "desc": "Query Parameter Definition",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RCP",
                            "desc": "Response Control Parameter",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "QBP_E22": {
        "desc": "Query Authorization Request",
        "name": "QBP_E22",
        "segments": {
            "desc": "Query Authorization Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QUERY",
                    "desc": "Query",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "QPD",
                            "desc": "Query Parameter Definition",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RCP",
                            "desc": "Response Control Parameter",
                            "min": 1,
                            "max": 1
                        }
                    ]
                }
            ]
        }
    },
    "QBP_Q11": {
        "desc": "Query By Parameter",
        "name": "QBP_Q11",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q13": {
        "desc": "Query By Parameter",
        "name": "QBP_Q13",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q15": {
        "desc": "Query By Parameter",
        "name": "QBP_Q15",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q21": {
        "desc": "Query By Parameter",
        "name": "QBP_Q21",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q22": {
        "desc": "Query By Parameter",
        "name": "QBP_Q22",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q23": {
        "desc": "Query By Parameter",
        "name": "QBP_Q23",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q24": {
        "desc": "Query By Parameter",
        "name": "QBP_Q24",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q25": {
        "desc": "Query Personnel Information Message",
        "name": "QBP_Q25",
        "segments": {
            "desc": "Query Personnel Information Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q31": {
        "desc": "QBP Message",
        "name": "QBP_Q31",
        "segments": {
            "desc": "QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Q32": {
        "desc": "Query By Parameter",
        "name": "QBP_Q32",
        "segments": {
            "desc": "Query By Parameter",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z73": {
        "desc": "QBP Message",
        "name": "QBP_Z73",
        "segments": {
            "desc": "QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z75": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z75",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z77": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z77",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z79": {
        "desc": "Query Grammar:  QBS Message",
        "name": "QBP_Z79",
        "segments": {
            "desc": "Query Grammar:  QBS Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z81": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z81",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z85": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z85",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z87": {
        "desc": "Query Grammar:  QBS Message",
        "name": "QBP_Z87",
        "segments": {
            "desc": "Query Grammar:  QBS Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z89": {
        "desc": "Query Grammar:  QBS Message",
        "name": "QBP_Z89",
        "segments": {
            "desc": "Query Grammar:  QBS Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z91": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z91",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z93": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z93",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z95": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z95",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z97": {
        "desc": "Query Grammar:  QBP Message",
        "name": "QBP_Z97",
        "segments": {
            "desc": "Query Grammar:  QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QBP_Z99": {
        "desc": "QBP Message",
        "name": "QBP_Z99",
        "segments": {
            "desc": "QBP Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RDF",
                    "desc": "Table Row Definition Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QCN_J01": {
        "desc": "Cancel Query",
        "name": "QCN_J01",
        "segments": {
            "desc": "Cancel Query",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QID",
                    "desc": "Query identification Segment",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "QRY_PC4": {
        "desc": "Query",
        "name": "QRY_PC4",
        "segments": {
            "desc": "Query",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QRY_PC9": {
        "desc": "Query",
        "name": "QRY_PC9",
        "segments": {
            "desc": "Query",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QRY_PCE": {
        "desc": "Query",
        "name": "QRY_PCE",
        "segments": {
            "desc": "Query",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QRY_PCK": {
        "desc": "Query",
        "name": "QRY_PCK",
        "segments": {
            "desc": "Query",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QSB_Q16": {
        "desc": "Create Subscription",
        "name": "QSB_Q16",
        "segments": {
            "desc": "Create Subscription",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QSB_Z83": {
        "desc": "Query Grammar:  QSB Message",
        "name": "QSB_Z83",
        "segments": {
            "desc": "Query Grammar:  QSB Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "QSX_J02": {
        "desc": "Cancel Subscription",
        "name": "QSX_J02",
        "segments": {
            "desc": "Cancel Subscription",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QID",
                    "desc": "Query identification Segment",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "QVR_Q17": {
        "desc": "Query for Previous Events",
        "name": "QVR_Q17",
        "segments": {
            "desc": "Query for Previous Events",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Event Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameters",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RAS_O17": {
        "desc": "Pharmacy/Treatment Administration",
        "name": "RAS_O17",
        "segments": {
            "desc": "Pharmacy/Treatment Administration",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ADDITIONAL_DEMOGRAPHICS",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Additional Demographics)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for PID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_DETAIL",
                            "desc": "Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy /Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL_SUPPLEMENT",
                                    "desc": "Order Detail Supplement",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "COMPONENTS",
                                            "desc": "Components",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for each RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ENCODING",
                            "desc": "Encoding",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Encoded Order)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING_ENCODED",
                                    "desc": "Timing Encoded",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ADMINISTRATION",
                            "desc": "Administration",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXA",
                                    "desc": "Pharmacy/Treatment Administration",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Administration)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "RCI_I05": {
        "desc": "Return Clinical Information",
        "name": "RCI_I05",
        "segments": {
            "desc": "Return Clinical Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RCL_I06": {
        "desc": "Return Clinical List",
        "name": "RCL_I06",
        "segments": {
            "desc": "Return Clinical List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSP",
                    "desc": "Display Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RDE_O11": {
        "desc": "Pharmacy/Treatment Encoded Order Message",
        "name": "RDE_O11",
        "segments": {
            "desc": "Pharmacy/Treatment Encoded Order Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Patient)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_DETAIL",
                            "desc": "Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Prescription Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "COMPONENT",
                                    "desc": "Component",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component (for RXO)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for each RXC)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RXE",
                            "desc": "Pharmacy/Treatment Encoded Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Encoded Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for RXE)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "TIMING_ENCODED",
                            "desc": "Timing Encoded",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RXR",
                            "desc": "Pharmacy/Treatment Route",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "RXC",
                            "desc": "Pharmacy/Treatment Component (for RXE)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Results",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for OBX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Detail",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "RDE_O25": {
        "desc": "Pharmacy/Treatment Refill Authorization Request",
        "name": "RDE_O25",
        "segments": {
            "desc": "Pharmacy/Treatment Refill Authorization Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Additional Demographics)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Patient ID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Information",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Additional Information, Certification",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        },
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_DETAIL",
                            "desc": "Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy/Treatment Prescription Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RXO)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "COMPONENTS",
                                    "desc": "Components",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component (for RXO)",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for each RXC)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RXE",
                            "desc": "Pharmacy/Treatment Encoded Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Encoded Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for Encoded Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "TIMING_ENCODED",
                            "desc": "Timing Encoded",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RXR",
                            "desc": "Pharmacy/Treatment Route",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "RXC",
                            "desc": "Pharmacy/Treatment Component (for RXE)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Results",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for OBX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Detail",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "BLG",
                            "desc": "Billing Segment",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "CTI",
                            "desc": "Clinical Trial Identification",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "RDR_RDR": {
        "desc": "Pharmacy/treatment Dispense Information",
        "name": "RDR_RDR",
        "segments": {
            "desc": "Pharmacy/treatment Dispense Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DEFINITION",
                    "desc": "Definition",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "QRD",
                            "desc": "Query Definition",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "QRF",
                            "desc": "Query Filter",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ENCODING",
                                    "desc": "Encoding",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "DISPENSE",
                                    "desc": "Dispense",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "RXD",
                                            "desc": "Pharmacy/Treatment Dispense",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RDS_O13": {
        "desc": "Pharmacy/Treatment Dispense Message",
        "name": "RDS_O13",
        "segments": {
            "desc": "Pharmacy/Treatment Dispense Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "ADDITIONAL_DEMOGRAPHICS",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Additional Demographics)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for PID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_DETAIL",
                            "desc": "Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy /Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL_SUPPLEMENT",
                                    "desc": "Order Detail Supplement",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "COMPONENT",
                                            "desc": "Component",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for each RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ENCODING",
                            "desc": "Encoding",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order Encoding)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING_ENCODED",
                                    "desc": "Timing Encoded",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RXD",
                            "desc": "Pharmacy/Treatment Dispense",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Treatment Dispense)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for RXD)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RXR",
                            "desc": "Pharmacy/Treatment Route",
                            "min": 1,
                            "max": 0
                        },
                        {
                            "name": "RXC",
                            "desc": "Pharmacy/Treatment Component",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Results",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Observation)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for OBX)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "FT1",
                            "desc": "Financial Transaction segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "RDY_K15": {
        "desc": "Display Based Response",
        "name": "RDY_K15",
        "segments": {
            "desc": "Display Based Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSP",
                    "desc": "Display Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RDY_Z80": {
        "desc": "Response Grammar:  Dispense History",
        "name": "RDY_Z80",
        "segments": {
            "desc": "Response Grammar:  Dispense History",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSP",
                    "desc": "Display Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RDY_Z98": {
        "desc": "Response Grammar:  Dispense History",
        "name": "RDY_Z98",
        "segments": {
            "desc": "Response Grammar:  Dispense History",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSP",
                    "desc": "Display Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "REF_I12": {
        "desc": "Patient Referral",
        "name": "REF_I12",
        "segments": {
            "desc": "Patient Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info -Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "REF_I13": {
        "desc": "Modify Patient Referral",
        "name": "REF_I13",
        "segments": {
            "desc": "Modify Patient Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info -Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "REF_I14": {
        "desc": "Cancel Patient Referral",
        "name": "REF_I14",
        "segments": {
            "desc": "Cancel Patient Referral",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info -Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "REF_I15": {
        "desc": "Request Patient Referral Status",
        "name": "REF_I15",
        "segments": {
            "desc": "Request Patient Referral Status",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info -Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RGV_O15": {
        "desc": "Pharmacy/Treatment Give",
        "name": "RGV_O15",
        "segments": {
            "desc": "Pharmacy/Treatment Give",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments (for PID)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AL1",
                            "desc": "Allergy Information",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT_VISIT",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Patient Visit)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER_DETAIL",
                            "desc": "Order Detail",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXO",
                                    "desc": "Pharmacy /Treatment Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ORDER_DETAIL_SUPPLEMENT",
                                    "desc": "Order Detail Supplement",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "COMPONENTS",
                                            "desc": "Components",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for each RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "PRT",
                            "desc": "Participation (for Order)",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ENCODING",
                            "desc": "Encoding",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "RXE",
                                    "desc": "Pharmacy/Treatment Encoded Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Encoded Order)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for RXE)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING_ENCODED",
                                    "desc": "Timing Encoded",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GIVE",
                            "desc": "Give",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RXG",
                                    "desc": "Pharmacy/Treatment Give",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING_GIVE",
                                    "desc": "Timing Give",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Results",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RPA_I08": {
        "desc": "Response to Treatment Authorization Information",
        "name": "RPA_I08",
        "segments": {
            "desc": "Response to Treatment Authorization Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info - Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RPA_I09": {
        "desc": "Response to Modification to an Authorization",
        "name": "RPA_I09",
        "segments": {
            "desc": "Response to Modification to an Authorization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info - Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RPA_I10": {
        "desc": "Response to Resubmission of an Authorization",
        "name": "RPA_I10",
        "segments": {
            "desc": "Response to Resubmission of an Authorization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info - Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RPA_I11": {
        "desc": "Response to Cancellation of an Authorization",
        "name": "RPA_I11",
        "segments": {
            "desc": "Response to Cancellation of an Authorization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Add'l Info - Cert",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RPI_I01": {
        "desc": "Return Patient Information",
        "name": "RPI_I01",
        "segments": {
            "desc": "Return Patient Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RPI_I04": {
        "desc": "Return Patient Information",
        "name": "RPI_I04",
        "segments": {
            "desc": "Return Patient Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RPL_I02": {
        "desc": "Return Patient Display List",
        "name": "RPL_I02",
        "segments": {
            "desc": "Return Patient Display List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSP",
                    "desc": "Display Data",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RPR_I03": {
        "desc": "Return Patient List",
        "name": "RPR_I03",
        "segments": {
            "desc": "Return Patient List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQA_I08": {
        "desc": "Request for Treatment Authorization Information",
        "name": "RQA_I08",
        "segments": {
            "desc": "Request for Treatment Authorization Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQA_I09": {
        "desc": "Request for Modification to an Authorization",
        "name": "RQA_I09",
        "segments": {
            "desc": "Request for Modification to an Authorization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQA_I10": {
        "desc": "Request for Resubmission of an Authorization",
        "name": "RQA_I10",
        "segments": {
            "desc": "Request for Resubmission of an Authorization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQA_I11": {
        "desc": "Request for Cancellation of an Authorization",
        "name": "RQA_I11",
        "segments": {
            "desc": "Request for Cancellation of an Authorization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION",
                    "desc": "Authorization",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION",
                            "desc": "Authorization",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS",
                            "desc": "Results",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "VISIT",
                    "desc": "Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQC_I05": {
        "desc": "Request for Patient Clinical Information",
        "name": "RQC_I05",
        "segments": {
            "desc": "Request for Patient Clinical Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQC_I06": {
        "desc": "Request/Receipt of Clinical Data Listing",
        "name": "RQC_I06",
        "segments": {
            "desc": "Request/Receipt of Clinical Data Listing",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification3",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQI_I01": {
        "desc": "Request for Insurance Information",
        "name": "RQI_I01",
        "segments": {
            "desc": "Request for Insurance Information",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQI_I02": {
        "desc": "Request/Receipt of Patient Selection Display List",
        "name": "RQI_I02",
        "segments": {
            "desc": "Request/Receipt of Patient Selection Display List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQI_I03": {
        "desc": "Request/Receipt of Patient Selection List",
        "name": "RQI_I03",
        "segments": {
            "desc": "Request/Receipt of Patient Selection List",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GUARANTOR_INSURANCE",
                    "desc": "Guarantor Insurance",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "GT1",
                            "desc": "Guarantor",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "INSURANCE",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IN1",
                                    "desc": "Insurance",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "IN2",
                                    "desc": "Insurance Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "IN3",
                                    "desc": "Insurance Add'l Info - Cert",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RQP_I04": {
        "desc": "Request for patient demographic data",
        "name": "RQP_I04",
        "segments": {
            "desc": "Request for patient demographic data",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PROVIDER",
                    "desc": "Provider",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RRA_O18": {
        "desc": "Pharmacy/Treatment Administration Acknowledgment Message",
        "name": "RRA_O18",
        "segments": {
            "desc": "Pharmacy/Treatment Administration Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for ORC)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ADMINISTRATION",
                                    "desc": "Administration",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "TREATMENT",
                                            "desc": "Treatment",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXA",
                                                    "desc": "Pharmacy/Treatment Administration",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PRT",
                                                    "desc": "Participation (for Administration)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RRD_O14": {
        "desc": "Pharmacy/Treatment Dispense Acknowledgment Message",
        "name": "RRD_O14",
        "segments": {
            "desc": "Pharmacy/Treatment Dispense Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for Patient ID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "DISPENSE",
                                    "desc": "Dispense",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXD",
                                            "desc": "Pharmacy/Treatment Dispense",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXD)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RRE_O12": {
        "desc": "Pharmacy/Treatment Encoded Order Acknowledgment Message",
        "name": "RRE_O12",
        "segments": {
            "desc": "Pharmacy/Treatment Encoded Order Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ENCODING",
                                    "desc": "Encoding",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXE)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RRE_O26": {
        "desc": "Pharmacy/Treatment Refill Authorization Request Acknowledgment Message",
        "name": "RRE_O26",
        "segments": {
            "desc": "Pharmacy/Treatment Refill Authorization Request Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ENCODING",
                                    "desc": "Encoding",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXE)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RRG_O16": {
        "desc": "Pharmacy/Treatment Give Acknowledgment Message",
        "name": "RRG_O16",
        "segments": {
            "desc": "Pharmacy/Treatment Give Acknowledgment Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments (for Header)",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GIVE",
                                    "desc": "Give",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXG",
                                            "desc": "Pharmacy/Treatment Give",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING_GIVE",
                                            "desc": "Timing Give",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RRI_I12": {
        "desc": "Response to Referral Information Request",
        "name": "RRI_I12",
        "segments": {
            "desc": "Response to Referral Information Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RRI_I13": {
        "desc": "Response to Modify Patient Referral Request",
        "name": "RRI_I13",
        "segments": {
            "desc": "Response to Modify Patient Referral Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RRI_I14": {
        "desc": "Response to Cancel Patient Referral Request",
        "name": "RRI_I14",
        "segments": {
            "desc": "Response to Cancel Patient Referral Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RRI_I15": {
        "desc": "Response to Patient Referral Status Request",
        "name": "RRI_I15",
        "segments": {
            "desc": "Response to Patient Referral Status Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "RF1",
                    "desc": "Referral Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "AUTHORIZATION_CONTACT",
                    "desc": "Authorization Contact",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "AUT",
                            "desc": "Authorization Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "PROVIDER_CONTACT",
                    "desc": "Provider Contact",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PRD",
                            "desc": "Provider Data",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "CTD",
                            "desc": "Contact Data",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ACC",
                    "desc": "Accident Information",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DG1",
                    "desc": "Diagnosis",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "DRG",
                    "desc": "Diagnosis Related Group",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "AL1",
                    "desc": "Allergy Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PROCEDURE",
                    "desc": "Procedure",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PR1",
                            "desc": "Procedure",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_CONTACT",
                            "desc": "Authorization Contact",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "AUT",
                                    "desc": "Authorization Information",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "OBSERVATION",
                    "desc": "Observation",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "OBR",
                            "desc": "Observation Request",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "RESULTS_NOTES",
                            "desc": "Results Notes",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "PATIENT_VISIT",
                    "desc": "Patient Visit",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments",
                    "min": 0,
                    "max": 0
                }
            ]
        }
    },
    "RSP_E03": {
        "desc": "HealthCare Services Invoice Query Response",
        "name": "RSP_E03",
        "segments": {
            "desc": "HealthCare Services Invoice Query Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QUERY_ACK",
                    "desc": "Query Ack",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "QAK",
                            "desc": "Query Acknowledgement",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "QPD",
                            "desc": "Query Parameter Definition",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "INVOICE_PROCESSING_RESULTS_INFO",
                            "desc": "Invoice Processing Results Info",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "IPR",
                                    "desc": "Invoice Processing Results",
                                    "min": 1,
                                    "max": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RSP_E22": {
        "desc": "Authorization Request Query Response",
        "name": "RSP_E22",
        "segments": {
            "desc": "Authorization Request Query Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QUERY_ACK",
                    "desc": "Query Ack",
                    "min": 1,
                    "max": 1,
                    "children": [
                        {
                            "name": "QAK",
                            "desc": "Query Acknowledgement",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "QPD",
                            "desc": "Query Parameter Definition",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "AUTHORIZATION_INFO",
                            "desc": "Authorization Info",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "IVC",
                                    "desc": "Invoice",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PSG",
                                    "desc": "Product/Service Group",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PSL_ITEM_INFO",
                                    "desc": "Psl Item Info",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "PSL",
                                            "desc": "Product/Service Line Item",
                                            "min": 1,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "RSP_K11": {
        "desc": "Segment Pattern Response",
        "name": "RSP_K11",
        "segments": {
            "desc": "Segment Pattern Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K21": {
        "desc": "Segment Pattern Response",
        "name": "RSP_K21",
        "segments": {
            "desc": "Segment Pattern Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "ARV",
                            "desc": "Access Restrictions",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "QRI",
                            "desc": "Query Response Instances",
                            "min": 1,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K22": {
        "desc": "Segment Pattern Response",
        "name": "RSP_K22",
        "segments": {
            "desc": "Segment Pattern Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "QRI",
                            "desc": "Query Response Instance",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K23": {
        "desc": "Segment Pattern Response",
        "name": "RSP_K23",
        "segments": {
            "desc": "Segment Pattern Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K24": {
        "desc": "Segment Pattern Response",
        "name": "RSP_K24",
        "segments": {
            "desc": "Segment Pattern Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K25": {
        "desc": "Personnel Information Response Message",
        "name": "RSP_K25",
        "segments": {
            "desc": "Personnel Information Response Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "STAFF",
                    "desc": "Staff",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "STF",
                            "desc": "Staff",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PRA",
                            "desc": "Practitioner",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ORG",
                            "desc": "Organization",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "AFF",
                            "desc": "Affiliation",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "LAN",
                            "desc": "Language",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "EDU",
                            "desc": "Education",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "CER",
                            "desc": "Certificate",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "ROL",
                            "desc": "Role",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K31": {
        "desc": "Pharmacy Dispense Message (Response)",
        "name": "RSP_K31",
        "segments": {
            "desc": "Pharmacy Dispense Message (Response)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RESPONSE",
                    "desc": "Response",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "ADDITIONAL_DEMOGRAPHICS",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PD1",
                                            "desc": "Additional Demographics",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Additional Demographics)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "AL1",
                                    "desc": "Allergy Information",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "PATIENT_VISIT",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PV1",
                                            "desc": "Patient Visit",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PV2",
                                            "desc": "Patient Visit - Additional Info",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Patient Visit)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "ORDER",
                            "desc": "Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXO",
                                            "desc": "Pharmacy/Treatment Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "COMPONENTS",
                                            "desc": "Components",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for each RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ENCODING",
                                    "desc": "Encoding",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXE)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 1,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXD",
                                    "desc": "Pharmacy/Treatment Dispense",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PRT",
                                    "desc": "Participation (for Order)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Results",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PRT",
                                            "desc": "Participation (for Observation)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_K32": {
        "desc": "Segment Pattern Response",
        "name": "RSP_K32",
        "segments": {
            "desc": "Segment Pattern Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info.",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "QRI",
                            "desc": "Query Response Instance",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_Z82": {
        "desc": "Response Grammar:  Pharmacy Dispense Message",
        "name": "RSP_Z82",
        "segments": {
            "desc": "Response Grammar:  Pharmacy Dispense Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VISIT",
                                    "desc": "Visit",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "AL1",
                                            "desc": "Allergy Information",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "PV1",
                                            "desc": "Patient Visit",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PV2",
                                            "desc": "Patient Visit - Additional Info",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "COMMON_ORDER",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXO",
                                            "desc": "Pharmacy/Treatment Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "TREATMENT",
                                            "desc": "Treatment",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ENCODED_ORDER",
                                    "desc": "Encoded Order",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXD",
                                    "desc": "Pharmacy/Treatment Dispense",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Results",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_Z84": {
        "desc": "RTB Message (Response)",
        "name": "RSP_Z84",
        "segments": {
            "desc": "RTB Message (Response)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_Z86": {
        "desc": "Response Grammar:  Pharmacy Information Comprehensive",
        "name": "RSP_Z86",
        "segments": {
            "desc": "Response Grammar:  Pharmacy Information Comprehensive",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "AL1",
                                    "desc": "Allergy Information",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "COMMON_ORDER",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXO",
                                            "desc": "Pharmacy/Treatment Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ENCODED_ORDER",
                                    "desc": "Encoded Order",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "DISPENSE",
                                    "desc": "Dispense",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXD",
                                            "desc": "Pharmacy/Treatment Dispense",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GIVE",
                                    "desc": "Give",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXG",
                                            "desc": "Pharmacy/Treatment Give",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ADMINISTRATION",
                                    "desc": "Administration",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXA",
                                            "desc": "Pharmacy/Treatment Administration",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Results",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RSP_Z88": {
        "desc": "Response Grammar:  Pharmacy Information Comprehensive",
        "name": "RSP_Z88",
        "segments": {
            "desc": "Response Grammar:  Pharmacy Information Comprehensive",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "ALLERGY",
                                    "desc": "Allergy",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "AL1",
                                            "desc": "Allergy Information",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "VISIT",
                                            "desc": "Visit",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "PV1",
                                                    "desc": "Patient Visit",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "PV2",
                                                    "desc": "Patient Visit - Additional Info",
                                                    "min": 0,
                                                    "max": 1
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "COMMON_ORDER",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER_DETAIL",
                                    "desc": "Order Detail",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXO",
                                            "desc": "Pharmacy/Treatment Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for RXO)",
                                            "min": 0,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "COMPONENT",
                                            "desc": "Component",
                                            "min": 0,
                                            "max": 1,
                                            "children": [
                                                {
                                                    "name": "RXC",
                                                    "desc": "Pharmacy/Treatment Component",
                                                    "min": 1,
                                                    "max": 0
                                                },
                                                {
                                                    "name": "NTE",
                                                    "desc": "Notes and Comments (for RXC)",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "name": "ORDER_ENCODED",
                                    "desc": "Order Encoded",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "RXE",
                                            "desc": "Pharmacy/Treatment Encoded Order",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TIMING_ENCODED",
                                            "desc": "Timing Encoded",
                                            "min": 0,
                                            "max": 0,
                                            "children": [
                                                {
                                                    "name": "TQ1",
                                                    "desc": "Timing/Quantity",
                                                    "min": 1,
                                                    "max": 1
                                                },
                                                {
                                                    "name": "TQ2",
                                                    "desc": "Timing/Quantity Order Sequence",
                                                    "min": 0,
                                                    "max": 0
                                                }
                                            ]
                                        },
                                        {
                                            "name": "RXR",
                                            "desc": "Pharmacy/Treatment Route",
                                            "min": 1,
                                            "max": 0
                                        },
                                        {
                                            "name": "RXC",
                                            "desc": "Pharmacy/Treatment Component",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "RXD",
                                    "desc": "Pharmacy/Treatment Dispense",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "RXR",
                                    "desc": "Pharmacy/Treatment Route",
                                    "min": 1,
                                    "max": 0
                                },
                                {
                                    "name": "RXC",
                                    "desc": "Pharmacy/Treatment Component",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Results",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "RSP_Z90": {
        "desc": "Response Grammar:  Pharmacy Information Comprehensive",
        "name": "RSP_Z90",
        "segments": {
            "desc": "Response Grammar:  Pharmacy Information Comprehensive",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "RCP",
                    "desc": "Response Control Parameter",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QUERY_RESPONSE",
                    "desc": "Query Response",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 1,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PD1",
                                    "desc": "Additional Demographics",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NK1",
                                    "desc": "Next of Kin/Associated Parties",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for PID)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "VISIT",
                                    "desc": "Visit",
                                    "min": 0,
                                    "max": 1,
                                    "children": [
                                        {
                                            "name": "PV1",
                                            "desc": "Patient Visit",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "PV2",
                                            "desc": "Patient Visit - Additional Info",
                                            "min": 0,
                                            "max": 1
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "COMMON_ORDER",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "ORC",
                                    "desc": "Common Order",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TIMING",
                                    "desc": "Timing",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "TQ1",
                                            "desc": "Timing/Quantity",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "TQ2",
                                            "desc": "Timing/Quantity Order Sequence",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "OBR",
                                    "desc": "Observations Report ID",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments (for ORC/OBR)",
                                    "min": 0,
                                    "max": 0
                                },
                                {
                                    "name": "CTD",
                                    "desc": "Contact Data",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "OBSERVATION",
                                    "desc": "Observation",
                                    "min": 1,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "OBX",
                                            "desc": "Observation/Result",
                                            "min": 0,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments (for OBX)",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Observation Related to Specimen",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 1,
                    "max": 1
                }
            ]
        }
    },
    "RTB_K13": {
        "desc": "Table Based Response",
        "name": "RTB_K13",
        "segments": {
            "desc": "Table Based Response",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Definition Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RTB_Z74": {
        "desc": "Personnel Information Message",
        "name": "RTB_Z74",
        "segments": {
            "desc": "Personnel Information Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RTB_Z76": {
        "desc": "Response Grammar: Who Am I",
        "name": "RTB_Z76",
        "segments": {
            "desc": "Response Grammar: Who Am I",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RTB_Z78": {
        "desc": "Response Grammar: Who Am I",
        "name": "RTB_Z78",
        "segments": {
            "desc": "Response Grammar: Who Am I",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RTB_Z92": {
        "desc": "Response Grammar: Who Am I",
        "name": "RTB_Z92",
        "segments": {
            "desc": "Response Grammar: Who Am I",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RTB_Z94": {
        "desc": "Response Grammar: Who Am I",
        "name": "RTB_Z94",
        "segments": {
            "desc": "Response Grammar: Who Am I",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "RTB_Z96": {
        "desc": "Response Grammar: Who Am I",
        "name": "RTB_Z96",
        "segments": {
            "desc": "Response Grammar: Who Am I",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QAK",
                    "desc": "Query Acknowledgement",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QPD",
                    "desc": "Query Parameter Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ROW_DEFINITION",
                    "desc": "Row Definition",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "RDF",
                            "desc": "Table Row Definition Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RDT",
                            "desc": "Table Row Data Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "SCN_S37": {
        "desc": "Anti-Microbial Device Cycle Data Notification",
        "name": "SCN_S37",
        "segments": {
            "desc": "Anti-Microbial Device Cycle Data Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SDD,SCD",
                    "desc": "Anti-microbial Device Cycle Data",
                    "min": 0,
                    "max": 0,
                    "compounds": [
                        {
                            "name": "SDD",
                            "desc": "SDD Segment",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SCD",
                            "desc": "SCD Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "SDN_S36": {
        "desc": "Anti-Microbial Device Data Notification",
        "name": "SDN_S36",
        "segments": {
            "desc": "Anti-Microbial Device Data Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SDD,SCD",
                    "desc": "Anti-microbial Device Data",
                    "min": 0,
                    "max": 0,
                    "compounds": [
                        {
                            "name": "SDD",
                            "desc": "SDD Segment",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SCD",
                            "desc": "SCD Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "SDR_S31": {
        "desc": "Anti-Microbial Device Data Request",
        "name": "SDR_S31",
        "segments": {
            "desc": "Anti-Microbial Device Data Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SDD,SCD",
                    "desc": "Anti-microbial Device Data",
                    "min": 0,
                    "max": 0,
                    "compounds": [
                        {
                            "name": "SDD",
                            "desc": "SDD Segment",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SCD",
                            "desc": "SCD Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S12": {
        "desc": "Notification of New Appointment Booking",
        "name": "SIU_S12",
        "segments": {
            "desc": "Notification of New Appointment Booking",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S13": {
        "desc": "Notification of Appointment Rescheduling",
        "name": "SIU_S13",
        "segments": {
            "desc": "Notification of Appointment Rescheduling",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S14": {
        "desc": "Notification of Appointment Modification",
        "name": "SIU_S14",
        "segments": {
            "desc": "Notification of Appointment Modification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S15": {
        "desc": "Notification of Appointment Cancellation",
        "name": "SIU_S15",
        "segments": {
            "desc": "Notification of Appointment Cancellation",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S16": {
        "desc": "Notification of Appointment Discontinuation",
        "name": "SIU_S16",
        "segments": {
            "desc": "Notification of Appointment Discontinuation",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S17": {
        "desc": "Notification of Appointment Deletion",
        "name": "SIU_S17",
        "segments": {
            "desc": "Notification of Appointment Deletion",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S18": {
        "desc": "Notification of Addition of Service/Resource on Appointment",
        "name": "SIU_S18",
        "segments": {
            "desc": "Notification of Addition of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S19": {
        "desc": "Notification of Modification of Service/Resource on Appointment",
        "name": "SIU_S19",
        "segments": {
            "desc": "Notification of Modification of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S20": {
        "desc": "Notification of Cancellation of Service/Resource on Appointment",
        "name": "SIU_S20",
        "segments": {
            "desc": "Notification of Cancellation of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S21": {
        "desc": "Notification of Discontinuation of Service/Resource on Appointment",
        "name": "SIU_S21",
        "segments": {
            "desc": "Notification of Discontinuation of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S22": {
        "desc": "Notification of Deletion of Service/Resource on Appointment",
        "name": "SIU_S22",
        "segments": {
            "desc": "Notification of Deletion of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S23": {
        "desc": "Notification of Blocked Schedule Time Slot(S)",
        "name": "SIU_S23",
        "segments": {
            "desc": "Notification of Blocked Schedule Time Slot(S)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S24": {
        "desc": "Notification of Opened (\"un-blocked\") Schedule Time Slot(s)",
        "name": "SIU_S24",
        "segments": {
            "desc": "Notification of Opened (\"un-blocked\") Schedule Time Slot(s)",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S26": {
        "desc": "Notification That Patient Did Not Show Up for Scheduled Appointment",
        "name": "SIU_S26",
        "segments": {
            "desc": "Notification That Patient Did Not Show Up for Scheduled Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SIU_S27": {
        "desc": "Broadcast Notification of Scheduled Appointments",
        "name": "SIU_S27",
        "segments": {
            "desc": "Broadcast Notification of Scheduled Appointments",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SCH",
                    "desc": "Schedule Activity Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TQ1",
                    "desc": "Timing/Quantity",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the SCH",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PD1",
                            "desc": "Additional Demographics",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SLN_S34": {
        "desc": "Notification of New Sterilization Lot",
        "name": "SLN_S34",
        "segments": {
            "desc": "Notification of New Sterilization Lot",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SLT",
                    "desc": "Sterilization Lot",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "SLN_S35": {
        "desc": "Notification of Sterilization Lot Deletion",
        "name": "SLN_S35",
        "segments": {
            "desc": "Notification of Sterilization Lot Deletion",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SLT",
                    "desc": "Sterilization Lot",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "SLR_S28": {
        "desc": "Request New Sterilization",
        "name": "SLR_S28",
        "segments": {
            "desc": "Request New Sterilization",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SLT",
                    "desc": "Sterilization Lot",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "SLR_S29": {
        "desc": "Request Sterilization Lot Deletion",
        "name": "SLR_S29",
        "segments": {
            "desc": "Request Sterilization Lot Deletion",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SLT",
                    "desc": "Sterilization Lot",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "SMD_S32": {
        "desc": "Anti-Microbial Device Cycle Data Request",
        "name": "SMD_S32",
        "segments": {
            "desc": "Anti-Microbial Device Cycle Data Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SDD,SCD",
                    "desc": "Anti-microbial Device Cycle Data",
                    "min": 0,
                    "max": 0,
                    "compounds": [
                        {
                            "name": "SDD",
                            "desc": "SDD Segment",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SCD",
                            "desc": "SCD Segment",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S01": {
        "desc": "Request New Appointment Booking",
        "name": "SRM_S01",
        "segments": {
            "desc": "Request New Appointment Booking",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S02": {
        "desc": "Request Appointment Rescheduling",
        "name": "SRM_S02",
        "segments": {
            "desc": "Request Appointment Rescheduling",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S03": {
        "desc": "Request Appointment Modification",
        "name": "SRM_S03",
        "segments": {
            "desc": "Request Appointment Modification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S04": {
        "desc": "Request Appointment Cancellation",
        "name": "SRM_S04",
        "segments": {
            "desc": "Request Appointment Cancellation",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S05": {
        "desc": "Request Appointment Discontinuation",
        "name": "SRM_S05",
        "segments": {
            "desc": "Request Appointment Discontinuation",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S06": {
        "desc": "Request Appointment Deletion",
        "name": "SRM_S06",
        "segments": {
            "desc": "Request Appointment Deletion",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S07": {
        "desc": "Request Addition of Service/Resource on Appointment",
        "name": "SRM_S07",
        "segments": {
            "desc": "Request Addition of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S08": {
        "desc": "Request Modification of Service/Resource on Appointment",
        "name": "SRM_S08",
        "segments": {
            "desc": "Request Modification of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S09": {
        "desc": "Request Cancellation of Service/Resource on Appointment",
        "name": "SRM_S09",
        "segments": {
            "desc": "Request Cancellation of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S10": {
        "desc": "Request Discontinuation of Service/Resource on Appointment",
        "name": "SRM_S10",
        "segments": {
            "desc": "Request Discontinuation of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRM_S11": {
        "desc": "Request Deletion of Service/Resource on Appointment",
        "name": "SRM_S11",
        "segments": {
            "desc": "Request Deletion of Service/Resource on Appointment",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ARQ",
                    "desc": "Appointment Request Information",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "APR",
                    "desc": "Appointment Preferences",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NTE",
                    "desc": "Notes and Comments for the ARQ",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Observation/Result",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "DG1",
                            "desc": "Diagnosis",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "RESOURCES",
                    "desc": "Resources",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "RGS",
                            "desc": "Resource Group Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SERVICE",
                            "desc": "Service",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIS",
                                    "desc": "Appointment Information - Service",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIS",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "GENERAL_RESOURCE",
                            "desc": "General Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIG",
                                    "desc": "Appointment Information - GENERAL_RESOURCE",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIG",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "LOCATION_RESOURCE",
                            "desc": "Location Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIL",
                                    "desc": "Appointment Information - Location Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIL",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "PERSONNEL_RESOURCE",
                            "desc": "Personnel Resource",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "AIP",
                                    "desc": "Appointment Information - Personnel Resource",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "APR",
                                    "desc": "Appointment Preferences",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes and Comments for the AIP",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S01": {
        "desc": "Response to New Appointment Booking Request",
        "name": "SRR_S01",
        "segments": {
            "desc": "Response to New Appointment Booking Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S02": {
        "desc": "Response to Appointment Rescheduling Request",
        "name": "SRR_S02",
        "segments": {
            "desc": "Response to Appointment Rescheduling Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S03": {
        "desc": "Response to Appointment Modification Request",
        "name": "SRR_S03",
        "segments": {
            "desc": "Response to Appointment Modification Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S04": {
        "desc": "Response to Appointment Cancellation Request",
        "name": "SRR_S04",
        "segments": {
            "desc": "Response to Appointment Cancellation Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S05": {
        "desc": "Response to Appointment Discontinuation Request",
        "name": "SRR_S05",
        "segments": {
            "desc": "Response to Appointment Discontinuation Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S06": {
        "desc": "Response to Appointment Deletion Request",
        "name": "SRR_S06",
        "segments": {
            "desc": "Response to Appointment Deletion Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S07": {
        "desc": "Response to Addition of Service/Resource on Appointment Request",
        "name": "SRR_S07",
        "segments": {
            "desc": "Response to Addition of Service/Resource on Appointment Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S08": {
        "desc": "Response to Modification of Service/Resource on Appointment Request",
        "name": "SRR_S08",
        "segments": {
            "desc": "Response to Modification of Service/Resource on Appointment Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S09": {
        "desc": "Response to Cancellation of Service/Resource on Appointment Request",
        "name": "SRR_S09",
        "segments": {
            "desc": "Response to Cancellation of Service/Resource on Appointment Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S10": {
        "desc": "Response to Discontinuation of Service/Resource on Appointment Request",
        "name": "SRR_S10",
        "segments": {
            "desc": "Response to Discontinuation of Service/Resource on Appointment Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SRR_S11": {
        "desc": "Response to Deletion of Service/Resource on Appointment Request",
        "name": "SRR_S11",
        "segments": {
            "desc": "Response to Deletion of Service/Resource on Appointment Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "ERR",
                    "desc": "Error Information",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "SCHEDULE",
                    "desc": "Schedule",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "SCH",
                            "desc": "Schedule Activity Information",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TQ1",
                            "desc": "Timing/Quantity",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "NTE",
                            "desc": "Notes and Comments for the SCH",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "PATIENT",
                            "desc": "Patient",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "PID",
                                    "desc": "Patient Identification",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "PV1",
                                    "desc": "Patient Visit",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "PV2",
                                    "desc": "Patient Visit - Additional Info",
                                    "min": 0,
                                    "max": 1
                                },
                                {
                                    "name": "DG1",
                                    "desc": "Diagnosis",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RESOURCES",
                            "desc": "Resources",
                            "min": 1,
                            "max": 0,
                            "children": [
                                {
                                    "name": "RGS",
                                    "desc": "Resource Group Segment",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "SERVICE",
                                    "desc": "Service",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIS",
                                            "desc": "Appointment Information - Service",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the RGS",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "GENERAL_RESOURCE",
                                    "desc": "General Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIG",
                                            "desc": "Appointment Information - GENERAL_RESOURCE",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIG",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "LOCATION_RESOURCE",
                                    "desc": "Location Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIL",
                                            "desc": "Appointment Information - Location Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIL",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                },
                                {
                                    "name": "PERSONNEL_RESOURCE",
                                    "desc": "Personnel Resource",
                                    "min": 0,
                                    "max": 0,
                                    "children": [
                                        {
                                            "name": "AIP",
                                            "desc": "Appointment Information - Personnel Resource",
                                            "min": 1,
                                            "max": 1
                                        },
                                        {
                                            "name": "NTE",
                                            "desc": "Notes and Comments for the AIP",
                                            "min": 0,
                                            "max": 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "SSR_U04": {
        "desc": "Specimen Status Message",
        "name": "SSR_U04",
        "segments": {
            "desc": "Specimen Status Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SPECIMEN_CONTAINER",
                    "desc": "Specimen Container",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SAC",
                            "desc": "Specimen Container Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "SPM",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "SSU_U03": {
        "desc": "Specimen Status Message",
        "name": "SSU_U03",
        "segments": {
            "desc": "Specimen Status Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SPECIMEN_CONTAINER",
                    "desc": "Specimen Container",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SAC",
                            "desc": "Specimen Container Detail",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "OBX",
                            "desc": "Additional specimen characteristics",
                            "min": 0,
                            "max": 0
                        },
                        {
                            "name": "SPECIMEN",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "SPM",
                                    "desc": "Specimen",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "OBX",
                                    "desc": "Specimen related observation",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "STC_S33": {
        "desc": "Sterilization Configuration Notification",
        "name": "STC_S33",
        "segments": {
            "desc": "Sterilization Configuration Notification",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SCP",
                    "desc": "Sterilization Configuration",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "STI_S30": {
        "desc": "Sterilization Item Request",
        "name": "STI_S30",
        "segments": {
            "desc": "Sterilization Item Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential Segment",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "SLT",
                    "desc": "Sterilization Lot",
                    "min": 1,
                    "max": 0
                }
            ]
        }
    },
    "TCR_U11": {
        "desc": "Test Code Settings Request",
        "name": "TCR_U11",
        "segments": {
            "desc": "Test Code Settings Request",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TEST_CONFIGURATION",
                    "desc": "Test Configuration",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SPM",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "TCC",
                            "desc": "Test Code Configuration",
                            "min": 1,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "TCU_U10": {
        "desc": "Test Code Settings Update",
        "name": "TCU_U10",
        "segments": {
            "desc": "Test Code Settings Update",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "EQU",
                    "desc": "Equipment Detail",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "TEST_CONFIGURATION",
                    "desc": "Test Configuration",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "SPM",
                            "desc": "Specimen",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "TCC",
                            "desc": "Test Code Configuration",
                            "min": 1,
                            "max": 0
                        }
                    ]
                },
                {
                    "name": "ROL",
                    "desc": "Role Detail",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "UDM_Q05": {
        "desc": "Unsolicited Display Message",
        "name": "UDM_Q05",
        "segments": {
            "desc": "Unsolicited Display Message",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software Segment",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "URD",
                    "desc": "Results/Update Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "URS",
                    "desc": "Results/Update Selection Criteria",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "DSP",
                    "desc": "Display Data",
                    "min": 1,
                    "max": 0
                },
                {
                    "name": "DSC",
                    "desc": "Continuation Pointer",
                    "min": 0,
                    "max": 1
                }
            ]
        }
    },
    "VXU_V04": {
        "desc": "Unsolicited Vaccination Update",
        "name": "VXU_V04",
        "segments": {
            "desc": "Unsolicited Vaccination Update",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PID",
                    "desc": "Patient Identification Segment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "PD1",
                    "desc": "Additional Demographics",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "NK1",
                    "desc": "Next of Kin/Associated Parties",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 0,
                    "max": 1,
                    "children": [
                        {
                            "name": "PV1",
                            "desc": "Patient Visit",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "PV2",
                            "desc": "Patient Visit - Additional Info",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "GT1",
                    "desc": "Guarantor",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "INSURANCE",
                    "desc": "Insurance",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "IN1",
                            "desc": "Insurance",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "IN2",
                            "desc": "Insurance Additional Information",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "IN3",
                            "desc": "Insurance Additional Information, Certification",
                            "min": 0,
                            "max": 1
                        }
                    ]
                },
                {
                    "name": "ORDER",
                    "desc": "Order",
                    "min": 0,
                    "max": 0,
                    "children": [
                        {
                            "name": "ORC",
                            "desc": "Common Order",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "TIMING",
                            "desc": "Timing",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "TQ1",
                                    "desc": "Timing/Quantity",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "TQ2",
                                    "desc": "Timing/Quantity Order Sequence",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        },
                        {
                            "name": "RXA",
                            "desc": "Pharmacy Administration Segment",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "RXR",
                            "desc": "Pharmacy Route",
                            "min": 0,
                            "max": 1
                        },
                        {
                            "name": "OBSERVATION",
                            "desc": "Observation",
                            "min": 0,
                            "max": 0,
                            "children": [
                                {
                                    "name": "OBX",
                                    "desc": "Observation/Result",
                                    "min": 1,
                                    "max": 1
                                },
                                {
                                    "name": "NTE",
                                    "desc": "Notes (Regarding Immunization)",
                                    "min": 0,
                                    "max": 0
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    "VXX_V02": {
        "desc": "Response to Vaccination Query",
        "name": "VXX_V02",
        "segments": {
            "desc": "Response to Vaccination Query",
            "segments": [
                {
                    "name": "MSH",
                    "desc": "Message Header",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "MSA",
                    "desc": "Message Acknowledgment",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "SFT",
                    "desc": "Software",
                    "min": 0,
                    "max": 0
                },
                {
                    "name": "UAC",
                    "desc": "User Authentication Credential",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "QRD",
                    "desc": "Query Definition",
                    "min": 1,
                    "max": 1
                },
                {
                    "name": "QRF",
                    "desc": "Query Filter",
                    "min": 0,
                    "max": 1
                },
                {
                    "name": "PATIENT",
                    "desc": "Patient",
                    "min": 1,
                    "max": 0,
                    "children": [
                        {
                            "name": "PID",
                            "desc": "Patient Identification",
                            "min": 1,
                            "max": 1
                        },
                        {
                            "name": "NK1",
                            "desc": "Next of Kin/Associated Parties",
                            "min": 0,
                            "max": 0
                        }
                    ]
                }
            ]
        }
    }
};

module.exports = messages;
